import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MiscInvoiceService } from './services/misc-invoice.service';
import * as moment from 'moment';
import { AllowIn, ShortcutInput } from 'ng-keyboard-shortcuts';
import { InvoiceServicesService } from '../invoice/flight/services/invoice-services.service';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TabService } from 'src/app/shared/services/tab.service';
import { CookiesService } from 'src/app/shared/cookies.service';
import * as FileSaver from 'file-saver'; 

@Component({
  selector: 'app-misc-invoice',
  templateUrl: './misc-invoice.component.html',
  styleUrls: ['./misc-invoice.component.scss'],
  providers: [MiscInvoiceService]
})


export class MiscInvoiceComponent implements OnInit {
  @Input() data;

  @ViewChild("subLedgerAC", { static: true }) subLedgerAC;
  @ViewChild("supplierAc", { static: true }) supplierAc;
  @ViewChild("supplier2Ac", { static: true }) supplier2Ac;
  @ViewChild("clientAC", { static: true }) clientAC;
  @ViewChild("generalLedgerAc", { static: true }) generalLedgerAc;
  @ViewChild("employeeAC", { static: true }) employeeAC;
  @ViewChild("ledgerCardAC", { static: true }) ledgerCardAC;
  @ViewChild("narrationArea", { static: true }) narrationArea;
  @ViewChild("tourAC",{ static:true }) tourAC
  
  // bookingSupplierArr: any;
  bookingClientArr: any = [];
  bookingSupplierArr: any = [];
  bookingGenerlaAccountArr: any = [];
  uniqueSupplier: any = []
  isSuccess: boolean = false;
	showMessage: boolean = false;
	alertType = ''
	message: string = ``;
  isHsnError : boolean = false;
  menuVisible : boolean = false;
  invoiceMode = 'save'
  loggedInuser: any;
  keyword="name";
	generalAccountArr: any;
  initialValue = '';
  employeeList: any;
  invoice_number: any;
  uuid: unknown;
  invoice_no: any = '';
  invoiceData: any;
  payablesArr: any = [];
  selectedClient: any;
  selectedSupplier: any=[]
  showTravellerIndex;
  maximizedSection: boolean;
  @ViewChildren('openModal') openModal: QueryList<ElementRef>;
  @ViewChild("openSuccessModal", { static: true }) openSuccessModal;
  staticInputCount = 10
  totalInputInTravellers = 55
  newInvoice = true;
  invoice_config: any;
  companyAddress: any;
	attachmentFile: File | null = null;
  isGstNumberExist: boolean = false;
  IncomeSetOff: string = 'true'
  groupList: any = [];
  isGSTInclusive: string = 'false'
  referedByArr: any=[]
  bookingTourArr: any = [];
  serviceConfig:string = "false"
  dropdownSettings = {}
  countryArr: any = []
  salesPersonConfig:string ='false'  
  referredByConfig:string = 'false'
  costCenterConfig:string = 'false'
  replicateClientXXLL	: string = "false"
  associatePayablesArr: any =[]
  associate_supp: string = 'false'
  clientCommissionConfig: any
  supplierCommissionConfig: any
  pnl_activate: string = 'false'
  associateTransaction = false
associateTransactionOnHQ = false

  @ViewChild('confirmDeleteModal', { static: true }) confirmDeleteModal: ElementRef;
  @ViewChild('closeDeleteModal', { static: true }) closeDeleteModal: ElementRef;
  @ViewChild('confirmUpdateModal', { static: true }) confirmUpdateModal: ElementRef
	@ViewChild('closeUpdateModal', { static: true }) closeUpdateModal: ElementRef
  @ViewChild('generateEInvoiceModal', {static: true}) generateEInvoiceModal: ElementRef 
  @ViewChild("corporateEmployeeAc", { static: true }) corporateEmployeeAc
  @ViewChild('closeSendEmailModal') closebutton;
	@ViewChild('openEmailModal') openEmailModal;
  queryParams: any;
  invoiceType = 'misc-invoice';
  transactionType: any;
  reInitialise: any;
  navigationSubscription: any;
	shortcuts: ShortcutInput[] = [];
  currentOpenedModal = ''
  sendEmailForm:FormGroup
  minDate; 
	maxDate;
  copyELementTitle = 'Click to Copy'
  hasError: boolean = false;
  isTenantIndian: boolean = false;
  currencyCode : string = "INR";
	nativeLanguageCode = '';
	showRefundableCheckbox: boolean = false;
  showPrintOptions: boolean = false
  isTesoyBoult: boolean  = false;
  checkEInvoice: boolean = false;
  salesCurrencyPrint: string = "false"
  paymentTypeColumn: string = "false"
  corporate_employee: string= "false"
  supplier_trans: string= "false"
  discount_add: string='false'
  employeeArr: any
  vatAlternetname: string = 'VAT'
  billOfSupplyActive: boolean = false;
  salesPersonArr: any=[];
  isAadesh: boolean = false;
  dateFormat = 'YYYY-MM-DD';
  isLocaleDateFormat: boolean = true;
  visaType: string = 'false'

  
  constructor(
    private formBuilder: FormBuilder,
    private invoiceService : InvoiceServicesService,
    public miscInvoiceService : MiscInvoiceService,
    public commonService: CommonServiceService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private cookiesService : CookiesService,
    public tabService: TabService,
  ) { 
		this.route.paramMap.subscribe(params => {
			this.invoice_no = params['params'].invoiceNumber
			this.transactionType = params['params'].transaction_type
      this.invoiceType = params['params'].invoice_type?params['params'].invoice_type:'misc-invoice'
      if(this.transactionType) {
          this.invoiceMode = 'save'
      } else {
        this.invoiceMode = 'view'
      }

      this.sendEmailForm = this.formBuilder.group({
        toEmails: ["",Validators.required],
        bccEmails: [''],
        ccEmails:[''],
        subject:[''],
        body:['']
      })
		});
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
			if (e instanceof NavigationEnd) {
				this.initialiseInvites();
			}
		});
  }

  initialiseInvites() {
		if (this.reInitialise) {
			this.ngOnInit()
		}
	}

  ngOnDestroy() {
		if(this.navigationSubscription){
			this.navigationSubscription.unsubscribe();
		}
	}
  
  async ngOnInit(){
       if(this.data) {
        this.invoice_no = this.data.invoice,
        this.invoiceMode = this.data.mode
        this.checkWhetherEInvGenerated(this.invoice_no)
        this.checkAssociateTransaction(this.invoice_no)
        this.checkAssociateTransactionOnHQ(this.invoice_no)
       }
  
    this.isTenantIndian = this.commonService.checkTenantIndian()

    if(this.isTenantIndian) {
      this.staticInputCount = 9
    }else {
      this.staticInputCount = 11
    }
  
    // this.getGeneralAccounts()
    this.getCompanyData()
    let data = {
      invoice_type : this.invoiceType,
      transaction_method : this.transactionType
    }
    this.miscInvoiceService.initialiseFormData(data,{})
    this.miscInvoiceService.initialiseTraveller()
    if(this.invoiceMode == 'save'){
      let loggedInUser = JSON.parse(localStorage.okountUserInfo);
      this.loggedInuser = loggedInUser
      this.miscInvoiceService.invoiceForm.controls.employee_name.setValue(
        loggedInUser.name
      );
      this.miscInvoiceService.invoiceForm.controls.employee_code.setValue(
        loggedInUser.accountcode
      );
    } else {
      if (this.invoiceMode == 'view' && this.invoice_no != undefined) {
        this.getMiscInvoiceData(this.invoice_no)
      }
    }
        this.getAccountingCompany()
    let empConfiguration = this.commonService.employeeConfiguration;
    if(!empConfiguration || empConfiguration.length == 0){
      let loggedInUser = JSON.parse(localStorage.okountUserInfo);
      empConfiguration = await this.commonService.getConfiguration(loggedInUser.accountcode)
    }
    
    let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}
    let transaction_config = globalSettingConfig.filter(el=>el.group=='TRANSACTION')
    if(transaction_config && transaction_config.length>0){
			console.log("transaction_config[0].json_doc",transaction_config[0].json_doc["value"])
      let currency_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='multi_currency_sale')
			if(currency_config && currency_config.length){
				this.salesCurrencyPrint = currency_config[0].value
			}
      let inv_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='corporate_employee')
      if(inv_config.length){
				this.corporate_employee = inv_config[0].value
			}
      let set_off_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='income_set_off')
			if(set_off_config && set_off_config.length){
				this.IncomeSetOff = set_off_config[0].value
			}
      
        let discount_config = transaction_config[0].json_doc.value.filter(el=>el.key=='DISCOUNT')
        if(discount_config.length){
          this.discount_add = discount_config[0].value
        }
        let gst_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='GST_Inclusive_Service_Charge')
      if(gst_config && gst_config.length){
          this.isGSTInclusive = gst_config[0].value
      }
      let payment_type_column_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='payment_type_coulmn')
      if(payment_type_column_config && payment_type_column_config.length){
        this.paymentTypeColumn = payment_type_column_config[0].value
      }
      
      let payable_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='PAYABLE TRANSACTION')
			if(payable_config && payable_config.length){
				this.supplier_trans = payable_config[0].value
			}
      let service_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='Custom Misc Services')
			if(service_config && service_config.length){
				this.serviceConfig = service_config[0].value
			}
      let sales_person_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='sales_person')
			if(sales_person_config && sales_person_config.length){
				this.salesPersonConfig = sales_person_config[0].value
			}
      let referred_by_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='referred_by')
			if(referred_by_config && referred_by_config.length){
        console.log("referred_by_config[0].value",referred_by_config[0].value)
				this.referredByConfig = referred_by_config[0].value
			}
      let cost_center_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='cost_center')
			if(cost_center_config && cost_center_config.length){
				this.costCenterConfig = cost_center_config[0].value
			}
      let replicateXXLCOnfig = transaction_config[0].json_doc.value.filter(el=>el.key=='Replicate XXl')
			if(replicateXXLCOnfig.length){
				this.replicateClientXXLL = replicateXXLCOnfig[0].value
			}
      let associateSuppConfig = transaction_config[0].json_doc.value.filter(el=>el.key=='Associate Supplier')
			if(associateSuppConfig.length){
				this.associate_supp = associateSuppConfig[0].value
			}
      let visa_type_config = transaction_config[0].json_doc["value"].filter(el=>el.key=='visa_type')
			if(visa_type_config && visa_type_config.length){
        this.visaType = visa_type_config[0].value
			}
      let dateConfig = await this.commonService.getDateFormat('date_format')
      this.dateFormat = dateConfig.dateFormat
      this.isLocaleDateFormat = dateConfig.isLocaleDateFormat
		}
    let pnl_config = globalSettingConfig.filter(el=>el.group=='P_N_L_SALES_PURCHASE')
    if(pnl_config && pnl_config.length>0){
      let pnl_enable_config = pnl_config[0].json_doc["value"].filter(el=>el.key=='Enable')
			if(pnl_enable_config && pnl_enable_config.length){
				this.pnl_activate = pnl_enable_config[0].value
			}
    }
    
    if(!this.isTenantIndian){
			let vat_value = globalSettingConfig.filter(el=>el.group=='VAT')
		if(vat_value.length){
			let vat_config = vat_value[0].json_doc.value.filter(el=>el.key=='vat_rate')
			let vat_detail,vat_name
			if(vat_config.length){
				 vat_detail = vat_config[0].value
			}
			if(vat_detail && vat_detail.length ){
				vat_name = vat_detail.filter(el=>el.key=='effective_name')
			}
			if(vat_name && vat_name.length){
				this.vatAlternetname = vat_name[0].value
			}
			console.log("vatAlternetname",this.vatAlternetname)

		}
		}

    this.invoiceDateValidation();

    if (this.invoiceMode != 'view') {
      this.invoice_config = this.miscInvoiceService.invoice_config[this.invoiceType] ? this.miscInvoiceService.invoice_config[this.invoiceType] : null
      if(this.invoice_config){
        this.generalSearch(this.invoice_config.general_ledger,true,true)
      }

			var url = window.location.href.slice(window.location.href.indexOf('?') + 1);
			this.getuuid(url)
      let queryParams = this.route.queryParams['value']
      if(queryParams){
        this.queryParams = queryParams
      }
     
		}
   this.showRefundableCheckbox = this.commonService.checkCreditNoteNonRefundableOrNot()
    this.reInitialise = true
    setTimeout(() => {
      this.commonService.selectedInput.next(4)
    }, 100);
    this.handleInvoiceForChange(this.invoiceType)
    // this.salesPersonSearch()
    // this.costCenterSearch()
    let userData = JSON.parse(this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA'))
		if(userData && userData.tenant_id && (userData.tenant_id == environment.aadeshSystaccId || userData.tenant_id == environment.aadeshAedSystaccId)) {
			this.isAadesh = true;
		}

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'location_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };

    this.getCountries()
}
invoiceDateValidation() {
  let financeYearResponse = this.commonService.checkFinancialYearValidation();
  // this.financialYearDiff = financeYearResponse.isFinancialYearDiff;
  this.minDate = financeYearResponse.minDate;
  this.maxDate = financeYearResponse.maxDate;
  if(this.invoiceMode != 'view')  this.miscInvoiceService.invoiceForm.controls.invoice_date.setValue(this.maxDate);
  this.miscInvoiceService.invoiceForm.controls.invoice_date.setValidators([Validators.required, this.validateDate()]);
  this.miscInvoiceService.invoiceForm.controls.invoice_date.updateValueAndValidity()
 
}    


  forceReload() {
		this.ngOnInit();
	}

  async initDateValidation (){
		try {
      this.minDate = moment().subtract(15, 'days').format('YYYY-MM-DD')
      this.maxDate = moment().format('YYYY-MM-DD')
      
			let config = this.commonService.getConfigurationByKey('misc-invoice')
			if(config){
				let dateConfig = config['value'].filter(data => data.key == `minimum_${this.invoiceMode == 'view' ? 'update' : 'creation'}_date`)
				let daysConfig = config['value'].filter(data => data.key == `minimum_${this.invoiceMode == 'view' ? 'update' : 'creation'}_days`)
				let dateWithMinDate = moment(dateConfig ? dateConfig[0].value : '')
        let dateWithMinDays = dateConfig && daysConfig[0].value ? moment().subtract(Number(daysConfig[0].value), 'days') : dateWithMinDate
				if(dateWithMinDays.isBefore(dateWithMinDate)){
					this.minDate = dateWithMinDate.format('YYYY-MM-DD')
				}else{
					this.minDate = dateWithMinDays.format('YYYY-MM-DD')
				}
			}
		} catch (error) {
			
		}
    this.miscInvoiceService.invoiceForm.controls.invoice_date.setValidators([Validators.required,this.validateDate()])
		this.miscInvoiceService.invoiceForm.controls.invoice_date.updateValueAndValidity()
  }
  
  validateDate(){
		return (control: AbstractControl) => {
			let valid = true
			if(this){
				if (moment(control.value).isBefore(this.minDate) || moment(control.value).isAfter(this.maxDate)) {
					if(this.invoiceMode == 'view' && this.invoiceData && this.invoiceData.invoice_date && moment(control.value).isSame(moment(this.invoiceData.invoice_date))){
            valid = true
          }else{
            valid = false
          }
				}
			}
			return !valid ? {invoice_date: {value: control.value}} : null;
		};
	}

  ngAfterViewInit(){

		this.shortcuts.push(			
			{
				key: "alt + s",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Save mis Entry",
				description: "Save mis Entry",
				
				command: (e)=>{
				console.log(e)	
			if(document.getElementById("save_mis_invoice_btn")){

				document.getElementById("save_mis_invoice_btn").click()
				setTimeout(() => {
				document.getElementsByTagName('body')[0].click()
				}, 100);
			}
					},
					preventDefault: true
			},
			{
				key: "alt + e",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Update Mis Entry",
				description: "Update Mis Entry",
				
				command: (e)=>{
				console.log(e)	
			if(document.getElementById("update_mis_invoice_btn")){

				document.getElementById("update_mis_invoice_btn").click()
				setTimeout(() => {
				document.getElementsByTagName('body')[0].click()
				}, 100);
			}
					},
					preventDefault: true
			},
			{
				key: "alt + d",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Delete Mis Entry",
				description: "Delete Mis Entry",
				
				command: (e)=>{
				console.log(e)	
			if(document.getElementById("delete_mis_invoice_btn")){

				document.getElementById("delete_mis_invoice_btn").click()
				setTimeout(() => {
				document.getElementsByTagName('body')[0].click()
				}, 100);
			}
					},
					preventDefault: true
			},
      {
				key: "alt + j",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Open Journal",
				description: "Open Journal",
				
				command: (e)=>{
				console.log(e)	
			if(document.getElementById("journal_ms_invoice_btn")){
				document.getElementById("journal_ms_invoice_btn").click()
				setTimeout(() => {
				document.getElementsByTagName('body')[0].click()
				}, 100);
			}
					},
					preventDefault: true
			},
      {
				key: "alt + plus",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Add New Row",
				description: "Add New Row",
				
				command: (e)=>{
        let updatedCount = this.miscInvoiceService.invoiceForm.value.number_of_pax+1
        this.miscInvoiceService.invoiceForm.controls.number_of_pax.setValue(updatedCount)
        this.miscInvoiceService.travellerCountUpdate(updatedCount)
        setTimeout(() => {
          document.getElementsByTagName('body')[0].click()
          }, 100);
					},
					preventDefault: true
			},
      {
				key: "alt + -",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Remove Last Row",
				description: "Remove Last Row",
				
				command: (e)=>{
          if(this.miscInvoiceService.invoiceForm.value.number_of_pax>0){
           let updatedCount = this.miscInvoiceService.invoiceForm.value.number_of_pax-1
           this.miscInvoiceService.invoiceForm.controls.number_of_pax.setValue(updatedCount)
            this.miscInvoiceService.removeTraveller(updatedCount)
          }
          setTimeout(() => {
            document.getElementsByTagName('body')[0].click()
            }, 100);
					},
					preventDefault: true
			},
      {
				key: "alt + y",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Clicked On Yes Button",
				description: "Clicked On Yes Button",
				
				command: (e)=>{
				if(this.currentOpenedModal=='update'){
					this.updateProduct()
					setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
				}else if(this.currentOpenedModal=='delete'){
					this.deleteInvoice(this.invoice_no)
					setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
				}
				this.currentOpenedModal = ''
					},
					preventDefault: true
			},
			{
				key: "alt + n",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Clicked On No Button",
				description: "Clicked On No Button",
				
				command: (e)=>{
				if(this.currentOpenedModal=='update'){
					this.closeUpdateConfirmModal()
					setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
				}else if(this.currentOpenedModal=='delete'){
					this.closeDeleteConfirmModal()
					setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
				}
				this.currentOpenedModal = ''
					},
					preventDefault: true
			},
      {
				key: ["alt + 1","alt + 2","alt + 3","alt + 4","alt + 5","alt + 6","alt + 7","alt + 8","alt + 9"],
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Edit  Traveller",
				description: "Edit  Traveller",
				
				command: (e)=>{
				console.log(e)
				   if(document.getElementById(`edit_traveller_${Number(e.event.key)-1}_btn`)){
					document.getElementById(`edit_traveller_${Number(e.event.key)-1}_btn`).click()
				   }
           setTimeout(() => {
						document.getElementsByTagName('body')[0].click()
						}, 100);
					},
					preventDefault: true
					
			},
      {
				key: "f10",
				allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
				label: "Send mail",
				description: "Send mail",
				command: (e)=>{
				console.log(e)	
				if(document.getElementById('mis_invoice_send_mail_btn') && this.invoiceMode=='view'){
					document.getElementById('mis_invoice_send_mail_btn').click()
					setTimeout(() => {
					document.getElementsByTagName('body')[0].click()
					}, 100);
				}
			},
					preventDefault: true
			},
      
	  )
	}
  
  getCompanyData() {
    return new Promise((resolve, reject) => {
			this.invoiceService.getMethod(`setting/address`).subscribe(
				res => {
					this.companyAddress = res
          resolve(res)
				},
				err => {
					reject({});
				}
			);
		});
  }

  async getuuid(url) {
		if (!url.includes('invoice_number') && this.invoiceMode != 'view') {
			this.uuid = await this.getInvoice()
			this.miscInvoiceService.invoiceForm.controls.invoice_number.setValue(this.uuid)
			window.history.replaceState({}, document.title, `/${window.location.hash}?invoice_number=${this.uuid}`);
		} else {
			if (url.split('=')[1] != undefined) {
				let invNo = url.split('=')[1]
				this.miscInvoiceService.invoiceForm.controls.invoice_number.setValue(invNo)
			}
		}
	}

  getInvoice() {
		return new Promise((resolve, reject) => {
			this.invoiceService.getMethod(`invoice/getuuid`).subscribe(
				res => {
					let invoiceNo;
					try {
						invoiceNo = res["uuid"]
						resolve(invoiceNo);
					} catch (error) {
						invoiceNo = res
						resolve(invoiceNo);
					}
				},
				err => {
					reject("");
				}
			);
		});
	}

  getMiscInvoiceData(searchId: any) {
		try {
			let url = `invoice/misc-invoice/${searchId}`
      this.spinner.show()
			this.invoiceService.getMethod(url).subscribe(async (res) => {
				let invoiceData = res['data'][0];
          if(invoiceData && invoiceData.accounting_company) {
            if(invoiceData['accounting_company'].currency_code) {
              this.currencyCode = invoiceData['accounting_company'].currency_code;
            }
            if(invoiceData['accounting_company'].native_language_code && invoiceData['accounting_company'].currency_code == 'AED') {
              this.nativeLanguageCode = invoiceData['accounting_company'].native_language_code;
            }
          }
          this.invoiceData = res['data'][0];
          // this.invoiceType = this.invoiceData.products[0].invoice_type
          let resp = await this.miscInvoiceService.bindInvoiceData(invoiceData)
          this.transactionType = this.invoiceData.transaction_method
          this.invoiceType = this.invoiceData.invoice_type? this.invoiceData.invoice_type : 'misc-invoice'
          this.initDateValidation()
          if(this.isTenantIndian) {
            this.staticInputCount = 9
          }else {
            this.staticInputCount = 11
          }
          this.clientSearch(this.invoiceData.account_code,false)
          this,invoiceData.products.forEach((product, index) => {
            this.payableSearch(product.payable_code,index)
          })

          if(this.invoiceMode == 'view' && this.invoiceData.bill_of_supply == false && !this.invoiceData.bos_reference) {
            let clientConfiguration:any = await this.commonService.getClientConfiguration(this.invoiceData.account_code);
            if(clientConfiguration && clientConfiguration.length > 0) {
              let bos = clientConfiguration.find(item => item.key == 'enable_bill_of_supply')
              if(bos && bos.value == 'TRUE') {
                this.billOfSupplyActive = true;
              }
            }
          } else {
            this.billOfSupplyActive = false
          }

          // this.generalSearch(this.invoiceData.general_ledger_code,true,false)
          this.ledgerSearch(this.invoiceData.subledger_code)
          this.spinner.hide()
			},
				err => {
					this.spinner.hide()
				})
		} catch (error) {
      this.spinner.hide()
		}
	}


	getGeneralAccounts() {
		try {
			this.invoiceService.getMethod(`general/bank-od-cc`).subscribe(data => {
				this.generalAccountArr = data
			}, err => {
				this.generalAccountArr = []
				throw new Error(JSON.stringify(err));
			})
		} catch (error) {

		}
	}
  getAssociateGeneralAccounts() {
		try {
			this.invoiceService.getMethod(`general/associate-bank-od-cc`).subscribe(data => {
				this.generalAccountArr = data
			}, err => {
				this.generalAccountArr = []
				throw new Error(JSON.stringify(err));
			})
		} catch (error) {

		}
	}

  	onChangeSearch(value) {
    		// this.bookingSupplierArr =  this.bookingSupplierArrBase.map(item => (item.account_code.includes(value) || item.name.includes(value)) );
    		
    	}
    
    	async selectAffiliateEvent(data){
    	}
    
    	async selectEvent(data) {
    	}
    
    	onFocused(e) {
    		
    	}

  hideError() {
    this.showMessage = false
  }

  closeMaxModule() {
    this.commonService.minimizeModule(true);
  }

    setNarration(){
      let services = this.miscInvoiceService.travellerForm.controls.travellerList.controls
      let travellerListLength = services.length
      let firstService = travellerListLength && services[0].controls

      var narrLine1= ''
      if (travellerListLength > 1) {
        narrLine1 = firstService.lead_pax_name.value && firstService.lead_pax_name.value.account_name?firstService.lead_pax_name.value.account_name:firstService.lead_pax_name.value + ' + ' + (travellerListLength - 1);
      } else {
        if(firstService.lead_pax_name && firstService.lead_pax_name.value)
          narrLine1 = firstService.lead_pax_name.value && firstService.lead_pax_name.value.account_name?firstService.lead_pax_name.value.account_name:firstService.lead_pax_name.value;
      }     
      
      var narrLine2 = ''
      var narrArr2 = []
     
      for(let i=0; i<2; i++){
        let serviceAtIndex = services[i] && services[i].controls ;
        if(serviceAtIndex && serviceAtIndex.service_name && serviceAtIndex.service_name.value){
          narrArr2.push(serviceAtIndex.service_name.value.toUpperCase())
        }
      }
      
      narrLine2= narrArr2.join(' + ');
      if(travellerListLength>2){
        narrLine2 += ` + MORE `
      }
      var narrLine3 = ''
      var narrArr3 = []
     
      for(let i=0; i<2; i++){
        let serviceAtIndex = services[i] && services[i].controls ;
        if(serviceAtIndex && serviceAtIndex.reference_number && serviceAtIndex.reference_number.value){
          narrArr3.push(serviceAtIndex.reference_number.value.toUpperCase())
        }
      }
      
      narrLine3= narrArr3.join(' + ');
      if(travellerListLength>2){
        narrLine3 += narrLine3.length ?` + MORE `:''
      }
      
      // var narrLine3= `${firstService['service_name'].value.toUpperCase()} - HSN:${firstService['hsn'].value}`;
      var narrLine4 = `ISSUED OFFLINE : ${this.miscInvoiceService.invoiceForm.controls.employee_name.value.toUpperCase()}`

      console.log(narrLine1, narrLine2, narrLine3,narrLine4);
      
      this.miscInvoiceService.invoiceForm.controls.narration_1.setValue(narrLine1)
      this.miscInvoiceService.invoiceForm.controls.narration_2.setValue(narrLine2)
      this.miscInvoiceService.invoiceForm.controls.narration_3.setValue(narrLine3)
      this.miscInvoiceService.invoiceForm.controls.narration_4.setValue(narrLine4)
  }

  getMasterConfiguration(payableAccountCode, travellerIndex, accountFor){
			this.commonService.getRequest(`${environment.okountUrl}/master_settings?account_code=${payableAccountCode}`).subscribe((res: any) => {
				if(res && res.length > 0){
          let data = res[0];
          if(accountFor == 'payable') {
            let tds = data && data.json_doc && data.json_doc.value && data.json_doc.value.find(item => item.key == 'tds')
            let gst = data && data.json_doc && data.json_doc.value && data.json_doc.value.find(item => item.key == 'gst')
            if(this.invoiceMode != 'view') {
            if(gst){
              let gstRate = gst.value.find(item => item.key == 'rate')
              if(gstRate && gstRate.value) {
                this.miscInvoiceService.travellerForm.controls.travellerList.controls[travellerIndex].controls.supplier_gst_conf.setValue(gstRate.value)
              }
            } else {
              this.miscInvoiceService.travellerForm.controls.travellerList.controls[travellerIndex].controls.supplier_gst_conf.setValue(0)
            }
            if(tds){
              let tdsRate = tds.value.find(item => item.key == 'rate')
              if(tdsRate && tdsRate.value) {
                this.miscInvoiceService.travellerForm.controls.travellerList.controls[travellerIndex].controls.supplier_tds_conf.setValue(tdsRate.value)
              }
            } else {
              this.miscInvoiceService.travellerForm.controls.travellerList.controls[travellerIndex].controls.supplier_tds_conf.setValue(0)
            }
          }

          this.calculateNetAmount(travellerIndex);
          
          }else if(accountFor == 'client' && this.isTenantIndian) {
            let tcs = data && data.json_doc && data.json_doc.value && data.json_doc.value.find(item => item.key == 'tcs')

            if(this.invoiceMode != 'view') {
              let billOfSupplyObj = data && data.json_doc && data.json_doc.value && data.json_doc.value.find(item => item.key == 'enable_bill_of_supply')
              if(billOfSupplyObj){
                let value = billOfSupplyObj.value;
                if(value == 'TRUE') {
                  this.billOfSupplyActive = true;
                }
              }
            } else {
              this.billOfSupplyActive = false
            }
           
            // if(tcs){
            //   let tcsRate = tcs.value.find(item => item.key == 'rate')
            //   if(tcsRate && tcsRate.value) {
            //     this.miscInvoiceService.invoiceForm.controls.tcs_rate.setValue(tcsRate.value)
            //   }
            // } else {
            //   this.miscInvoiceService.invoiceForm.controls.tcs_rate.setValue(0)
            // }
          }
				} else if(accountFor == 'client') {
            this.miscInvoiceService.invoiceForm.controls.tcs_rate.setValue(0)
            this.miscInvoiceService.invoiceForm.controls.tcs_amount.setValue(0)
        } else if(accountFor == 'payable') {
            this.miscInvoiceService.travellerForm.controls.travellerList.controls[travellerIndex].controls.supplier_gst_conf.setValue(0)
            this.miscInvoiceService.travellerForm.controls.travellerList.controls[travellerIndex].controls.supplier_tds_conf.setValue(0)
        }
			},err=> {
		})
  }

  selectAccount(value, formControlName, index) {
    try {
      if(formControlName == 'ledger_card_no') {
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.ledger_card_no.setValue(value.account_code ? value.account_code : '')
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.ledger_card_name.setValue(value.name ? value.name : '')
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.ledger_card_tenant_id.setValue(value.tenant_id ? value.tenant_id : '')
        return;
      }
      if(formControlName == 'general_ledger_code') {
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.general_ledger_code.setValue(value.account_code ? value.account_code : '')
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.general_ledger_code_name.setValue(value.name ? value.name : '')
        return;
      }
      if(formControlName == 'payable_code') {
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.payable_code.setValue(value.account_code ? value.account_code : '')
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.payable_account_name.setValue(value.name ? value.name : '')
      
        let payableAccountCode = this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.payable_code.value
        if(payableAccountCode) this.getMasterConfiguration(payableAccountCode, index, 'payable')
          this.selectedSupplier[index] = value
        this.miscInvoiceService.calculateFromApi(0)
      this.calcuateAllSC()
         if(value && value.is_branch==false && this.invoiceMode == 'view') {
            this.miscInvoiceService.invoiceForm.controls[`associate_supplier_tenant_id`].setValue(null);
         }
          this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls[`payable_account_is_branch`].setValue(value && value.hasOwnProperty('is_branch') ? value.is_branch : '');
          this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls["associate_payable_code"].setValue(value && value.hasOwnProperty('is_branch')  && value.is_branch==false?'':this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls["associate_payable_code"].value ? this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls["associate_payable_code"].value : '');
          this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls[`associate_payable_account_name`].setValue(value && value.hasOwnProperty('is_branch')  && value.is_branch==false?'':this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls[`associate_payable_account_name`].value ? this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls[`associate_payable_account_name`].value : '');
          // }
          if(value.is_branch==true){
            this.invoiceService.searchAccount(
            `supplier/AssociateAutocomplete?company_name=${this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.payable_account_name.value}`
          )
          .subscribe(
            (res) => {
              this.associatePayablesArr = res;
            },
            (error) => {}
          );
          }
           if(this.invoiceMode != 'view') {
            this.getCommissionConfig(null,value.account_code,this.miscInvoiceService.invoiceForm.controls.invoice_date.value,'received',index)
            this.miscInvoiceService.calculateFromApi(index)

           }
        return;
      }
      if(formControlName == 'associate_payable_code') {
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.associate_payable_code.setValue(value.account_code ? value.account_code : '')
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.associate_payable_account_name.setValue(value.name ? value.name : '')
        this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls[`associate_supplier_tenant_id`].setValue(value && value.tenant_id ? value.tenant_id : '');
        return;
      }
      this.miscInvoiceService.invoiceForm.controls[formControlName].setValue(
        value && value.account_code ? value.account_code : ''
      );
      this.miscInvoiceService.invoiceForm.controls[`${formControlName}_name`].setValue(
        value && value.name ? value.name : ''
      );
     

      if(formControlName == 'client_code'){
        this.selectedClient = value
        if(value && value.account_code){
          this.getMasterConfiguration(value.account_code ? value.account_code : '', null, 'client')
          if(this.invoiceMode != 'view') {
            this.getCommissionConfig(value.account_code,null,this.miscInvoiceService.invoiceForm.controls.invoice_date.value,'paid',null)

          }
          this.miscInvoiceService.calculateFromApi(0)
        }
        this.calcuateAllSC()
          if(this.invoiceMode != 'view') {
        if(value["sales_person"] && value["sales_person_name"]) {
            if(this.isValidJSON(value.sales_person_name)) {
               this.miscInvoiceService.invoiceForm.controls.sales_person_name.setValue(JSON.parse(value.sales_person_name).name ? JSON.parse(value.sales_person_name).name : value.sales_person_name); // Clear the invalid input
            } else {
               this.miscInvoiceService.invoiceForm.controls.sales_person_name.setValue(value.sales_person_name);
            }
            this.miscInvoiceService.invoiceForm.controls.sales_person_code.setValue(value.sales_person)
        }
      }
      }
      if(formControlName == 'payable_code'){
        this.selectedSupplier[index] = value
        this.calcuateAllSC()
      }
    } catch (error) {}
  }

  getCommissionConfig(client_Code,supplier_code,invdate,commission_type,index) {
        let url = `${environment.okountUrl}/Commission-config/config?client_code=${client_Code?client_Code:''}&supplier_code=${supplier_code?supplier_code:''}&service=${this.miscInvoiceService.invoiceForm.value.transaction_method=='sales'?'miscellaneous-invoice':'miscellaneous-credit-note'}&invoice_date=${invdate}&commission_type=${commission_type}`;
        this.commonService.getRequest(url).subscribe(
          async (res: any) => {
            if(commission_type=='paid'){
              this.clientCommissionConfig = res['data'][0]
            } else{
              this.supplierCommissionConfig = res['data'][0]
            } 
            let travellers = this.miscInvoiceService.travellerForm.get("travellerList");
            if(travellers && travellers.controls.length>0) {
              travellers.controls.forEach((item, i) => {
                 if(this.clientCommissionConfig?.com_type) item.controls.client_commission_type.setValue(this.clientCommissionConfig?.com_type);
                  if(this.clientCommissionConfig?.commission_value)item.controls.client_commission_value.setValue(this.clientCommissionConfig?.commission_value);
                  if(this.supplierCommissionConfig?.com_type && i==index) item.controls.supplier_commission_type.setValue(this.supplierCommissionConfig?.com_type);
                  if(this.supplierCommissionConfig?.commission_value && i==index)item.controls.supplier_commission_value.setValue(this.supplierCommissionConfig?.commission_value);
                });
            }
          }
        );
      }

      CommissionConfig(){
              this.getCommissionConfig(this.miscInvoiceService.invoiceForm.controls.client_code.value,null,this.miscInvoiceService.invoiceForm.controls.invoice_date.value,'paid',null)

      }
  

  clientSearch(value,withStatus) {
    try {
      let searchType = this.miscInvoiceService.invoiceForm.controls.client_account_type.value;
      if (searchType == null) {
        this.miscInvoiceService.invoiceForm.controls.client_account_type.setValue(
          "client"
        );
        searchType = this.miscInvoiceService.invoiceForm.controls.client_account_type.value;
      }
      if (value.length > 2 && searchType != null && searchType != "") {
        let status = ''
        if(withStatus){
          status = '&status=active'
        }
        this.invoiceService
          .searchAccount(
            `${searchType}/autocomplete?name_like=${value.toUpperCase()}${status}`
          )
          .subscribe(
            (res) => {
              this.bookingClientArr = res;
              if(this.bookingClientArr[0] && this.invoiceMode == 'view'){
                this.selectAccount(this.bookingClientArr[0],'client_code', null)
              }
            },
            (error) => {}
          );
      }
    } catch (error) {
      console.error(error)
    }
  }

  tourSearch(value,withStatus) {
    try {
      let searchType = 'general'
      if (value.length > 2 ) {
        let status = ''
        if(withStatus){
          status = '&status=active'
        }
        this.invoiceService
          .searchAccount(
            `${searchType}/autocomplete?name_like=${value.toUpperCase()}${status}&sub_type=tour`
          )
          .subscribe(
            (res) => {
              this.bookingTourArr = res;
              if(this.bookingTourArr[0] && this.invoiceMode == 'view'){
                this.selectAccount(this.bookingTourArr[0],'tour_code', null)
              }
            },
            (error) => {}
          );
      }else {
        this.bookingTourArr = [];
      }
    } catch (error) {
      console.error(error)
    }
  }

  generalSearch(value,isSelect,withStatus) {
    try {
     
      if (value.length > 2) {
        let status = '';
        if(withStatus){
          status = '&status=active'
        }
        this.invoiceService
          .searchAccount(
            `general/autocomplete?name_like=${value.toUpperCase()}${status}`
          )
          .subscribe(
            (res) => {
              this.bookingGenerlaAccountArr = res;
              if(this.bookingGenerlaAccountArr[0] && isSelect){
                this.selectAccount(this.bookingGenerlaAccountArr[0],'general_ledger_code', 0)
              }
            },
            (error) => {}
          );
      }
    } catch (error) {
      console.error(error)
    }
  }

  supplierSearch(value,withStatus) {
    try {
      let searchType = this.miscInvoiceService.invoiceForm.controls.supplier_account_type.value;
      if (searchType == null) {
        this.miscInvoiceService.invoiceForm.controls.supplier_account_type.setValue(
          "supplier"
        );
        searchType = this.miscInvoiceService.invoiceForm.controls.supplier_account_type.value;
      }
      if (value.length > 2 && searchType != null && searchType != "") {
        let status = '';
        if(withStatus){
          status = '&status=active'
        }
        this.invoiceService
          .searchAccount(
            `${searchType}/autocomplete?name_like=${value.toUpperCase()}${status}`
          )
          .subscribe(
            (res) => {
              this.bookingSupplierArr = res;
              if(this.bookingSupplierArr[0] && this.invoiceMode == 'view'){
                this.selectAccount(this.bookingSupplierArr[0],'supplier_code', null)
              }
            },
            (error) => {}
          );
      }
    } catch (error) {}
  }

  ledgerSearch(value) {
    try {
      let searchType = this.miscInvoiceService.invoiceForm.controls
        .subledger_type.value;
      
      if (searchType == null) {
        this.miscInvoiceService.invoiceForm.controls.subledger_type.setValue(
          "client"
        );
        searchType = this.miscInvoiceService.invoiceForm.controls
          .subledger_type.value;
      }
      if (value.length > 2 && searchType != null && searchType != "") {
        let status = '';
        if(this.invoiceMode != 'view'){
          status = '&status=active'
        }
        this.invoiceService
          .searchAccount(
            `${searchType}/autocomplete?name_like=${value.toUpperCase()}${status}`
          )
          .subscribe(
            (res) => {
              this.miscInvoiceService["ledgerList"] = res;
              if (value == "CC001A" || value == "CC001B") {
                this.selectAccount(res[0], "subledger_code", null);
                this.miscInvoiceService.invoiceForm.controls.subledger_code_name.setValue(
                  res[0].name
                );
              }
              if(this.invoiceMode == 'view') {
                this.selectAccount(res[0], "subledger_code", null);
              }
            },

            
            (error) => {}
          );
      }
    } catch (error) {}
  }

  employeeSearch(value) {
    try {
      if (value.length > 2) {
        this.invoiceService
          .searchAccount(
            `employee/autocomplete?name_like=${value.toUpperCase()}`
          )
          .subscribe(
            (res) => {
              this.employeeList = res;
            },
            (error) => {}
          );
      }
    } catch (error) {}
  }
  // onFocused(e) {}

  payableSearch(value, index) {
    try {
      let searchType = this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.payable_account_type.value;

      if (value.length > 2 && searchType != null && searchType != "") {
        let status = ''
        this.invoiceService
          .searchAccount(
            `${searchType}/autocomplete?name_like=${value.toUpperCase()}${status}`
          )
          .subscribe(
            (res) => {
              this.payablesArr = res;
              if(this.payablesArr[0] && this.invoiceMode == 'view'){
                this.selectAccount(this.payablesArr.find(el=>el.account_code==value),'payable_code', index)
              }
            },
            (error) => {}
          );
      }
    } catch (error) {
    }
  }

  associatePayableSearch(value, index) {
    try {
        let status = ''
        if(!this.associatePayablesArr || this.associatePayablesArr == undefined || this.associatePayablesArr == null|| !this.associatePayablesArr.length) {

        this.invoiceService
          .searchAccount(
            `supplier/AssociateAutocomplete?company_name=${this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.payable_account_name.value.name?this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.payable_account_name.value.name:this.miscInvoiceService.travellerForm.controls.travellerList.controls[index].controls.payable_account_name.value}`
          )
          .subscribe(
            (res) => {
              this.associatePayablesArr = res;
              if(this.associatePayablesArr[0] && this.invoiceMode == 'view'){
                this.selectAccount(this.associatePayablesArr.filter(el=>el.account_code==value),'associate_payable_code', index)
              }
            },
            (error) => {}
          );
        }else{
          if(value) {
            this.associatePayablesArr = this.associatePayablesArr.filter(account => (account.name.includes(value.toUpperCase?value.toUpperCase():value) || account.account_code.includes(value.toUpperCase?value.toUpperCase():value)))
          }
        }
    } catch (error) {
    }
  }



  async saveProductInvoice() {
    if(this.commonService.gstFiledDate) {
			if(moment(this.commonService.gstFiledDate).isSameOrAfter(moment(this.miscInvoiceService.invoiceForm.controls.invoice_date.value).format('YYYY-MM-DD'))) {
				this.showMessage = true
				this.spinner.hide()
				this.alertType = "error-box"
				this.message = 'Not Allowed to create the invoice.'
				return false;
			}
		}
    
    if(this.miscInvoiceService.invoiceForm.value.bill_of_supply === true) {
      let checkBosApplicableOrNot = this.checkBosApplicableOrNot(this.miscInvoiceService.travellerForm.value)
      if(!checkBosApplicableOrNot) {
        this.showMessage = true
        this.spinner.hide()
        this.alertType = "error-box"
        this.message = 'Bill of supply Not Applicable.'
        return false;
      }
    }
    if(this.isGstNumberExist){
      await this.checkHsn(this.miscInvoiceService.travellerForm.value)
    if(this.isHsnError==true){ 
      window.scroll(0,0)
      this.showMessage = true;
      this.isSuccess = false
      this.invoice_number = ''
      this.alertType = 'error-box';
      this.message = `Enter Hsn Code for all Service Charges`
      this.spinner.hide()
      return false
    }
    if(this.selectedClient && this.selectedClient.account_code){

      const res = await this.invoiceService.getMethod(`client/autocomplete?name_like=${this.selectedClient.account_code.toUpperCase()}&status=active&client_type=all`).toPromise()
    // const res = await this.invoiceService.getMethod(`client?client_code=${this.selectedClient.account_code.toUpperCase()}&status=active`).toPromise()

    let data = (res as any[]).filter((data)=>data.account_code==this.selectedClient.account_code)
    if(!data[0]["state_id"] || data[0]["state_id"] ==0 || !data[0]["state_name"]) {
            window.scroll(0,0)
            this.showMessage = true;
            this.isSuccess = false
            this.invoice_number = ''
            this.alertType = 'error-box';
            this.message = `Update Client With State Code`
            this.spinner.hide()
            return false
          }   
        }
      }
      for (let traveller of this.miscInvoiceService.travellerForm.value.travellerList) {
        if((traveller.pay_type == "OUR_CC"||traveller.pay_type == "ASSOCIATE_CC") && (traveller.ledger_card_no == undefined || traveller.ledger_card_no == "" || traveller.ledger_card_no == null)) {
          this.showMessage = true
          this.alertType = "error-box"
          this.message = "Please select the card"
          this.spinner.hide()
          return ;
        }
        if(this.pnl_activate=='false'){
          let salesAmounr = Number(traveller.client_basic) + Number(traveller.client_taxes)
          let purchaseAmount = Number(traveller.supplier_basic) + Number(traveller.supplier_taxes) 
          if(salesAmounr != purchaseAmount) {
            this.showMessage = true
            this.alertType = "error-box"
            this.message = "Ensure that the client-side basic and tax amounts are aligned with the supplier-side values."
            this.spinner.hide()
            return ;
          }
        }
      }
    await this.initDateValidation()
    if (this.invoiceMode == "view") {
      this.updateProduct();
    } else {
      const invalid = [];
      const controls = this.miscInvoiceService.invoiceForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }

      const travellerControls = this.miscInvoiceService.travellerForm.controls.travellerList.controls;
      for(let item of travellerControls) {
        let itemControls = item.controls
        for (const name in itemControls) {
          if (itemControls[name].invalid) {
            invalid.push(name);
          }
        }
      }

      if(invalid.length > 0) {
        window.scroll(0,0)
        this.showMessage = true;
        this.isSuccess = false
        this.invoice_number = ''
        this.alertType = 'error-box';
        this.message = `Invalid field ${invalid[0]} ${invalid.length > 1 ? `+${invalid.length-1}` : ''}`
        this.spinner.hide()
        return false
      }

  
      this.spinner.show()

      let product_json_doc = this.miscInvoiceService.createMsProduct(
        this.miscInvoiceService.invoiceForm.value,this.miscInvoiceService.travellerForm.value
      );

      if(this.invoiceMode != 'view' && this.miscInvoiceService.invoiceForm.value.bill_of_supply === true) { 
        let billOfSupplyRequest = this.miscInvoiceService.createMsProductForBillSupply(
          this.miscInvoiceService.invoiceForm.value,this.miscInvoiceService.travellerForm.value
        );
        product_json_doc['billOfSupplyRequest'] = billOfSupplyRequest
      } 

      this.miscInvoiceService.postMethod(`invoice/misc-invoice`,product_json_doc).subscribe(async (data) => {
      // this.miscInvoiceService.postMethod(``,product_json_doc).subscribe(async (data) => {
        window.scroll(0, 0)
        this.invoice_number = data['invoice_number']
        this.showMessage = false;
        this.isSuccess = true
        this.alertType = 'success-box';
        this.message = `Invoice Saved with invoice no. : `
        this.miscInvoiceService.initialiseFormData({},{})
        let loggedInUser = JSON.parse(localStorage.okountUserInfo);
        this.loggedInuser = loggedInUser
        this.miscInvoiceService.invoiceForm.controls.employee_name.setValue(
          loggedInUser.name
        );
        this.miscInvoiceService.invoiceForm.controls.employee_code.setValue(
          loggedInUser.accountcode
        );
        this.miscInvoiceService.travellerList.controls = [];
        this.miscInvoiceService.addTraveller({})
        let obj = {
          invoice_no: 'New Invoice',
        };
        this.miscInvoiceService.fareList = []
        this.miscInvoiceService.fareList.push(obj);
        this.miscInvoiceService.calculateFromApi(0)
        this.uuid = await this.getInvoice()
        this.miscInvoiceService.invoiceForm.controls.invoice_number.setValue(this.uuid)
        window.history.replaceState({}, document.title, `/${window.location.hash}?invoice_number=${this.uuid}`);
        this.spinner.hide()
        this.newInvoice = false;
        this.openSuccessModal.nativeElement.click()
        setTimeout(() => {
          this.commonService.selectedInput.next(1)
        }, 100);
      },err=> {
        window.scroll(0, 0)
        this.showMessage = true;
        this.isSuccess = false
        this.invoice_number = ''
        this.alertType = 'error-box';
        this.message = err['error']['message']
        this.spinner.hide()
      })
      
    }
  }
  
  async saveDraftInvoice() {
    
    await this.initDateValidation()
    if (this.invoiceMode == "view") {
      this.updateProduct();
    } else {
  
      this.spinner.show()

      let product_json_doc = this.miscInvoiceService.createMsProduct(
        this.miscInvoiceService.invoiceForm.value,this.miscInvoiceService.travellerForm.value
      );

      if(this.invoiceMode != 'view' && this.miscInvoiceService.invoiceForm.value.bill_of_supply === true) { 
        let billOfSupplyRequest = this.miscInvoiceService.createMsProductForBillSupply(
          this.miscInvoiceService.invoiceForm.value,this.miscInvoiceService.travellerForm.value
        );
        product_json_doc['billOfSupplyRequest'] = billOfSupplyRequest
      } 

      this.miscInvoiceService.postMethod(`invoice/draft-misc-invoice`,product_json_doc).subscribe(async (data) => {
      // this.miscInvoiceService.postMethod(``,product_json_doc).subscribe(async (data) => {
        window.scroll(0, 0)
        this.invoice_number = data['id']
        this.showMessage = false;
        this.isSuccess = true
        this.alertType = 'success-box';
        this.message = `Invoice Saved as Draft`
        this.miscInvoiceService.initialiseFormData({},{})
        let loggedInUser = JSON.parse(localStorage.okountUserInfo);
        this.loggedInuser = loggedInUser
        this.miscInvoiceService.invoiceForm.controls.employee_name.setValue(
          loggedInUser.name
        );
        this.miscInvoiceService.invoiceForm.controls.employee_code.setValue(
          loggedInUser.accountcode
        );
        this.miscInvoiceService.travellerList.controls = [];
        this.miscInvoiceService.addTraveller({})
        let obj = {
          invoice_no: 'New Invoice',
        };
        this.miscInvoiceService.fareList = []
        this.miscInvoiceService.fareList.push(obj);
        this.miscInvoiceService.calculateFromApi(0)
        this.uuid = await this.getInvoice()
        this.miscInvoiceService.invoiceForm.controls.invoice_number.setValue(this.uuid)
        window.history.replaceState({}, document.title, `/${window.location.hash}?invoice_number=${this.uuid}`);
        this.spinner.hide()
        this.newInvoice = false;
        this.openSuccessModal.nativeElement.click()
        setTimeout(() => {
          this.commonService.selectedInput.next(1)
        }, 100);
      },err=> {
        window.scroll(0, 0)
        this.showMessage = true;
        this.isSuccess = false
        this.invoice_number = ''
        this.alertType = 'error-box';
        this.message = err['error']['message']
        this.spinner.hide()
      })
      
    }
  }


  async updateProduct() {
    const invalid = [];
      const controls = this.miscInvoiceService.invoiceForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      const travellerControls = this.miscInvoiceService.travellerForm.controls.travellerList.controls;
      for(let item of travellerControls) {
        let itemControls = item.controls
        for (const name in itemControls) {
          if (itemControls[name].invalid) {
            invalid.push(name);
          }
        }
      }
      if(invalid.length > 0) {
        window.scroll(0,0)
        this.showMessage = true;
        this.isSuccess = false
        this.invoice_number = ''
        this.alertType = 'error-box';
        this.message = `Invalid field ${invalid[0]} ${invalid.length > 1 ? `+${invalid.length-1}` : ''}`
        this.spinner.hide()
        this.closeUpdateConfirmModal()
        return false
    }
    this.closeUpdateConfirmModal()
    this.spinner.show()
    if(this.isGstNumberExist){
      await this.checkHsn(this.miscInvoiceService.travellerForm.value)
    if(this.isHsnError==true){ 
      window.scroll(0,0)
      this.showMessage = true;
      this.isSuccess = false
      this.invoice_number = ''
      this.alertType = 'error-box';
      this.message = `Enter Hsn Code for all Service Charges`
      this.spinner.hide()
      return false
    }
    if(this.selectedClient && this.selectedClient.account_code){
      const res = await this.invoiceService.getMethod(`client/autocomplete?name_like=${this.selectedClient.account_code.toUpperCase()}&status=active&client_type=all`).toPromise()
    // const res = await this.invoiceService.getMethod(`client?client_code=${this.selectedClient.account_code.toUpperCase()}&status=active`).toPromise()

    let data = (res as any[]).filter((data)=>data.account_code==this.selectedClient.account_code)
    if(!data[0]["state_id"] || data[0]["state_id"] ==0 || !data[0]["state_name"]) {
      window.scroll(0,0)
      this.showMessage = true;
      this.isSuccess = false
      this.invoice_number = ''
      this.alertType = 'error-box';
      this.message = `Update Client With State Code`
      this.spinner.hide()
      return false
    }   
  }
}
for (let traveller of this.miscInvoiceService.travellerForm.value.travellerList) {
  if((traveller.pay_type == "OUR_CC"||traveller.pay_type == "ASSOCIATE_CC") && (traveller.ledger_card_no == undefined || traveller.ledger_card_no == "" || traveller.ledger_card_no == null)) {
    this.showMessage = true
    this.alertType = "error-box"
    this.message = "Please select the card"
    this.spinner.hide()
    return ;
  }
  if(this.pnl_activate=='false'){
    let salesAmounr = Number(traveller.client_basic) + Number(traveller.client_taxes)
    let purchaseAmount = Number(traveller.supplier_basic) + Number(traveller.supplier_taxes) 
    if(salesAmounr != purchaseAmount) {
      this.showMessage = true
      this.alertType = "error-box"
      this.message = "client basic + client taxes should be equal to supplier basic + supplier taxes"
      this.spinner.hide()
      return ;
    }
  }
}
      const invoiceFormValue = JSON.parse(JSON.stringify(this.miscInvoiceService.invoiceForm.value))
      let product_json_doc = this.miscInvoiceService.createMsProduct(
        invoiceFormValue,this.miscInvoiceService.travellerForm.value
      );

      if(!this.invoiceData.bos_reference && this.miscInvoiceService.invoiceForm.value.bill_of_supply === true) { 
        let billOfSupplyRequest = JSON.parse(JSON.stringify(product_json_doc))
        let originalRequest = this.miscInvoiceService.createMsProductForBillSupply(
          this.miscInvoiceService.invoiceForm.value,this.miscInvoiceService.travellerForm.value
        );

        product_json_doc = originalRequest;
        product_json_doc['billOfSupplyRequest'] = billOfSupplyRequest;
        product_json_doc['billOfSupplyRequest']['bill_of_supply'] = true;

      } 
      this.miscInvoiceService.putMethod(`invoice/misc-invoice/${this.invoice_no}`,product_json_doc).subscribe(async (data) => {
        window.scroll(0, 0)
        this.showMessage = true;
        this.isSuccess = true
        this.alertType = 'success-box';
        this.message = `Invoice Updated`

        if(product_json_doc['billOfSupplyRequest'] && product_json_doc['billOfSupplyRequest']['bill_of_supply'] === true) {
          this.forceReload();
          return;
        } 
        if(product_json_doc.status == 'draft'||product_json_doc.status == 'Draft'){
          this.invoice_number = data['invoice_number']
          this.showMessage = true;
          this.alertType = 'success-box';
          this.isSuccess = true
          this.message = `Invoice Saved with invoice no. : ${this.invoice_number}`
        this.miscInvoiceService.initialiseFormData({},{})

        let loggedInUser = JSON.parse(localStorage.okountUserInfo);
        this.loggedInuser = loggedInUser
        this.miscInvoiceService.invoiceForm.controls.employee_name.setValue(
          loggedInUser.name
        );
        this.miscInvoiceService.invoiceForm.controls.employee_code.setValue(
          loggedInUser.accountcode
        );
        this.miscInvoiceService.travellerList.controls = [];
        this.miscInvoiceService.addTraveller({})
        let obj = {
          invoice_no: 'New Invoice',
        };
        this.miscInvoiceService.fareList = []
        this.miscInvoiceService.fareList.push(obj);
        this.miscInvoiceService.calculateFromApi(0)
        this.uuid = await this.getInvoice()
        this.miscInvoiceService.invoiceForm.controls.invoice_number.setValue(this.uuid)
        window.history.replaceState({}, document.title, `/${window.location.hash}?invoice_number=${this.uuid}`);
        this.newInvoice = false;
        this.openSuccessModal.nativeElement.click()
          // setTimeout(()=>{
          //   window.top.close()
          // },5000)
        }
        this.spinner.hide()
      },err=> {
        window.scroll(0, 0)
        this.showMessage = true;
        this.isSuccess = false
        this.invoice_number = ''
        this.alertType = 'error-box';
        this.message = err['error']['message']
        this.spinner.hide()
      })
      
  }
  calcuateAllSC(){
    let controls = this.miscInvoiceService.travellerForm.controls.travellerList.controls
      for (let i = 0; i < controls.length; i++) {
        this.calcuateSC(i)
      }
  }

  calcuateSC(i){
    const invoiceData = this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].value
    let gstRate = this.getGstRate(i)
    let client_igst = 0
    let client_igst_2 = 0
    let client_igst_3 = 0
    let client_sgst = 0
    let client_sgst_2 = 0
    let client_sgst_3 = 0
    let client_cgst = 0
    let client_cgst_2 = 0
    let client_cgst_3 = 0
    let clientTotalAmount = 0
    let clientTotalAmount_2 = 0
    let clientTotalAmount_3 = 0
    let client_vat_amount = 0
    let client_igst_on_raf = 0
    let client_cgst_on_raf = 0
    let client_sgst_on_raf = 0
    let client_vat_on_raf = 0

    let clientRafAmount =  Number(invoiceData.client_raf_charges ? invoiceData.client_raf_charges : 0);


   
    if(invoiceData.client_gst_type== 'S'|| invoiceData.client_vat_type== 'S'){
      clientTotalAmount = invoiceData.client_sc1_type == 'T' ? Number(invoiceData.client_sc1_amount) : 0
    }
    if(invoiceData.client_gst_type== 'B' || invoiceData.client_vat_type== 'B'){
      clientTotalAmount = !isNaN(Number(invoiceData.client_basic)) ? Number(invoiceData.client_basic) : 0
    }
    if(invoiceData.client_gst_type== 'TOTAL' || invoiceData.client_vat_type== 'T'){
      clientTotalAmount = this.calculateTotal("client",i)
    }

    if(invoiceData.client_gst_type_2== 'TOTAL'){
      clientTotalAmount_2 =  this.calculateTotal("client",i)

    }
    if(invoiceData.client_gst_type_2== 'B'){
      clientTotalAmount_2 = Number(!isNaN(Number(invoiceData.client_basic)) ? Number(invoiceData.client_basic) : 0)+Number(invoiceData.client_sc2_type == 'B'?invoiceData.client_sc2_amount:0)+Number(invoiceData.client_sc3_type == 'B'?invoiceData.client_sc3_amount:0)
    }
    if(invoiceData.client_gst_type_2== 'S'){
      clientTotalAmount_2 = invoiceData.client_sc1_type == 'T' ? Number(invoiceData.client_sc1_amount) : 0
    }

    if (invoiceData.client_gst_type_3 == 'TOTAL') {
      clientTotalAmount_3 = this.calculateTotal("client",i)
    }
    if (invoiceData.client_gst_type_3 == 'B') {
      clientTotalAmount_3 = Number(!isNaN(Number(invoiceData.client_basic)) ? Number(invoiceData.client_basic) : 0)+Number(invoiceData.client_sc2_type == 'B'?invoiceData.client_sc2_amount:0)+Number(invoiceData.client_sc3_type == 'B'?invoiceData.client_sc3_amount:0)
    }
    if (invoiceData.client_gst_type_3 == 'S') {
      clientTotalAmount_3 = invoiceData.client_sc1_type == 'T' ? Number(invoiceData.client_sc1_amount) : 0
    }


    if(this.isTenantIndian){
      if(gstRate.client_igst_applicable){
        client_igst = Number((clientTotalAmount * gstRate.client_gst_rate/100).toFixed(2))
        client_igst_2 = Number((clientTotalAmount_2 * gstRate.client_gst_rate_2/100).toFixed(2))
        client_igst_3 = Number((clientTotalAmount_3 * gstRate.client_gst_rate_3/100).toFixed(2))
        client_igst_on_raf = Number((clientRafAmount * 18/100).toFixed(2))
  
      }else{
        let rate = gstRate.client_gst_rate/2
        let rate_2 = gstRate.client_gst_rate_2/2
      let rate_3 = gstRate.client_gst_rate_3/2
        client_cgst = Number((clientTotalAmount * rate/100).toFixed(2))
        client_sgst = Number((clientTotalAmount * rate/100).toFixed(2))
        client_cgst_2 = Number((clientTotalAmount_2 * rate_2/100).toFixed(2))
      client_sgst_2 = Number((clientTotalAmount_2 * rate_2/100).toFixed(2))
      client_cgst_3 = Number((clientTotalAmount_3 * rate_3/100).toFixed(2))
      client_sgst_3 = Number((clientTotalAmount_3 * rate_3/100).toFixed(2))
      client_cgst_on_raf = Number((clientRafAmount * 9/100).toFixed(2))
      client_sgst_on_raf = Number((clientRafAmount * 9/100).toFixed(2))

      }
    } else {
      client_vat_amount += Number((clientTotalAmount * gstRate.client_vat_rate/100).toFixed(2))
      client_vat_on_raf = Number((clientRafAmount * gstRate.client_vat_rate/100).toFixed(2))

    }


    let supplier_igst = 0
    let supplier_igst_2 = 0
    let supplier_igst_3 = 0
    let supplier_sgst = 0
    let supplier_sgst_2 = 0
    let supplier_sgst_3 = 0
    let supplier_cgst = 0
    let supplier_cgst_2 = 0
    let supplier_cgst_3 = 0
    let supplierTotalAmount = 0
    let supplierTotalAmount_2 = 0
    let supplierTotalAmount_3 = 0
    let supplier_vat_amount = 0
    let supplier_igst_on_raf = 0
    let supplier_cgst_on_raf = 0
    let supplier_sgst_on_raf = 0
    let supplier_vat_on_raf = 0

    let supplierRafAmount =  Number(invoiceData.supplier_raf_charges ? invoiceData.supplier_raf_charges : 0);

    if(invoiceData.supplier_gst_type== 'S' || invoiceData.supplier_vat_type == 'S'){
      supplierTotalAmount = invoiceData.supplier_sc1_type == 'T' ? Number(invoiceData.supplier_sc1_amount) : 0
    }
    if(invoiceData.supplier_gst_type== 'B' || invoiceData.supplier_vat_type == 'B'){
      supplierTotalAmount = !isNaN(Number(invoiceData.supplier_basic)) ? Number(invoiceData.supplier_basic) : 0
    }
    if(invoiceData.supplier_gst_type== 'TOTAL' || invoiceData.supplier_vat_type == "T"){
      supplierTotalAmount = this.calculateTotal("supplier",i)
    }
   
    // if (invoiceData.supplier_sc2_taxable == 'T') {
      if (invoiceData.supplier_gst_type_2 == 'TOTAL') {
        supplierTotalAmount_2 = this.calculateTotal("supplier",i)
      }
      if (invoiceData.supplier_gst_type_2 == 'B') {
        supplierTotalAmount_2 = !isNaN(Number(invoiceData.supplier_basic)) ? Number(invoiceData.supplier_basic) : 0
      }
      if (invoiceData.supplier_gst_type_2 == 'S') {
        //supplierTotalAmount_2 = invoiceData.supplier_sc2_type == 'T' ? Number(invoiceData.supplier_sc2_amount) : 0
        supplierTotalAmount_2 = invoiceData.supplier_sc1_type == 'T' ? Number(invoiceData.supplier_sc1_amount) : 0
      }
    // }
    // if (invoiceData.supplier_sc3_taxable == 'T') {
      if (invoiceData.supplier_gst_type_3 == 'TOTAL') {
        supplierTotalAmount_3 = this.calculateTotal("supplier",i)
      }
      if (invoiceData.supplier_gst_type_3 == 'B') {
        supplierTotalAmount_3 = !isNaN(Number(invoiceData.supplier_basic)) ? Number(invoiceData.supplier_basic) : 0
      }
      if (invoiceData.supplier_gst_type_3 == 'S') {
        //supplierTotalAmount_3 = invoiceData.supplier_sc3_type == 'T' ? Number(invoiceData.supplier_sc3_amount) : 0
        supplierTotalAmount_3 = invoiceData.supplier_sc1_type == 'T' ? Number(invoiceData.supplier_sc1_amount) : 0
      }
    // }

    if(this.isTenantIndian){
      if(gstRate.supplier_igst_applicable){
        supplier_igst = Number((supplierTotalAmount * gstRate.supplier_gst_rate/100).toFixed(2))
        supplier_igst_2 = Number((supplierTotalAmount_2 * gstRate.supplier_gst_rate_2/100).toFixed(2))
        supplier_igst_3 = Number((supplierTotalAmount_3 * gstRate.supplier_gst_rate_3/100).toFixed(2))
        supplier_igst_on_raf = Number((supplierRafAmount * 18/100).toFixed(2))

      }else{
        let rate = gstRate.supplier_gst_rate/2
        let rate_2 = gstRate.supplier_gst_rate_2/2
      let rate_3 = gstRate.supplier_gst_rate_3/2
        supplier_cgst = Number((supplierTotalAmount * rate/100).toFixed(2))
        supplier_sgst = Number((supplierTotalAmount * rate/100).toFixed(2))
        supplier_cgst_2 = Number((supplierTotalAmount_2 * rate_2/100).toFixed(2))
        supplier_sgst_2 = Number((supplierTotalAmount_2 * rate_2/100).toFixed(2))
        supplier_cgst_3 = Number((supplierTotalAmount_3 * rate_3/100).toFixed(2))
        supplier_sgst_3 = Number((supplierTotalAmount_3 * rate_3/100).toFixed(2))
        supplier_cgst_on_raf = Number((supplierRafAmount * 9/100).toFixed(2))
        supplier_sgst_on_raf = Number((supplierRafAmount * 9/100).toFixed(2))

      }
    }else {
      supplier_vat_amount = Number((supplierTotalAmount * gstRate.supplier_vat_rate/100).toFixed(2))
      supplier_vat_on_raf = Number((supplierRafAmount * gstRate.supplier_vat_rate/100).toFixed(2))

    }
  
    // TODO : Fix gst calculation
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_cgst.setValue(client_cgst)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_sgst.setValue(client_sgst)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_igst.setValue(client_igst)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_cgst_2.setValue(client_cgst_2)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_sgst_2.setValue(client_sgst_2)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_igst_2.setValue(client_igst_2)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_cgst_3.setValue(client_cgst_3)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_sgst_3.setValue(client_sgst_3)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_igst_3.setValue(client_igst_3)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_igst_on_raf.setValue(client_igst_on_raf)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_cgst_on_raf.setValue(client_cgst_on_raf)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_sgst_on_raf.setValue(client_sgst_on_raf)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_vat_on_raf.setValue(client_vat_on_raf)

    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_vat_amount.setValue(client_vat_amount)

    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_cgst.setValue(supplier_cgst)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_sgst.setValue(supplier_sgst)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_igst.setValue(supplier_igst)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_cgst_2.setValue(supplier_cgst_2)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_sgst_2.setValue(supplier_sgst_2)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_igst_2.setValue(supplier_igst_2)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_cgst_3.setValue(supplier_cgst_3)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_sgst_3.setValue(supplier_sgst_3)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_igst_3.setValue(supplier_igst_3)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_igst_on_raf.setValue(supplier_igst_on_raf)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_cgst_on_raf.setValue(supplier_cgst_on_raf)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_sgst_on_raf.setValue(supplier_sgst_on_raf)
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_vat_on_raf.setValue(supplier_vat_on_raf)

    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_vat_amount.setValue(supplier_vat_amount)

    return true
  }

  calculateTotal(calculation_key,i){
    const invoiceData = this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].value
    
    let nonAccount = invoiceData[`${calculation_key}_non_account`]
    let basic = invoiceData[`${calculation_key}_basic`]
    let taxes = invoiceData[`${calculation_key}_taxes`]
    let commission_amount = invoiceData[`${calculation_key}_commission_amount`]
    let discount_amount = invoiceData[`${calculation_key}_discount_amount`]
    let tds = invoiceData[`${calculation_key}_tds_amount`]
    let sc1_type = invoiceData[`${calculation_key}_sc1_type`]
    let sc1_amount = invoiceData[`${calculation_key}_sc1_amount`]
    let sc2_type = invoiceData[`${calculation_key}_sc2_type`]
    let sc2_amount = invoiceData[`${calculation_key}_sc2_amount`]
    let sc3_type = invoiceData[`${calculation_key}_sc3_type`]
    let sc3_amount = invoiceData[`${calculation_key}_sc3_amount`]

    let total = Number(nonAccount) + Number(basic) + Number(taxes) - Number(commission_amount) - Number(discount_amount) + Number(tds)
    // if(sc1_type == 'T'){
      total += Number(sc1_amount)
    // }
    // if(sc2_type == 'T'){
      total += Number(sc2_amount)
    // }
    // if(sc3_type == 'T'){
      total += Number(sc3_amount)
    // }
    return !isNaN(Number(total)) ? Number(total) : 0
  }


  getGstRate(i) {
    let formValue = this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].value
    let client_gst_rate = formValue.client_gst_conf ? formValue.client_gst_conf : 0
    let client_gst_rate_2 = formValue.client_gst_conf_2 ? formValue.client_gst_conf_2 : 0
    let client_gst_rate_3 = formValue.client_gst_conf_3 ? formValue.client_gst_conf_3 : 0
    let supplier_gst_rate = formValue.supplier_gst_conf ? formValue.supplier_gst_conf : 0
    let supplier_gst_rate_2 = formValue.supplier_gst_conf_2 ? formValue.supplier_gst_conf_2 : 0
    let supplier_gst_rate_3 = formValue.supplier_gst_conf_3 ? formValue.supplier_gst_conf_3 : 0
    let client_vat_rate = formValue.client_vat_conf ? formValue.client_vat_conf : 0
    let supplier_vat_rate = formValue.supplier_vat_conf ? formValue.supplier_vat_conf : 0
    let supplier_igst_applicable = this.selectedSupplier && this.selectedSupplier[i] && this.selectedSupplier[i].country_id && this.selectedSupplier[i].country_id==101 ? this.checkIsIgstApplicable(this.selectedSupplier[i].gst_number,this.selectedSupplier[i].state_id) : true
    let client_igst_applicable = this.selectedClient  && this.selectedClient.country_id == 101  ? this.checkIsIgstApplicable(this.selectedClient.gst_number,this.selectedClient.state_id) : true
    return {
      client_gst_rate,
      client_gst_rate_2,
      client_gst_rate_3,
      supplier_gst_rate,
      supplier_gst_rate_2,
      supplier_gst_rate_3,
      supplier_igst_applicable,
      client_igst_applicable,
      client_vat_rate,
      supplier_vat_rate
    }
  }

  checkIsIgstApplicable(otherGstNumber, otherState) {
    let accountingCompanyGstNumber = this.companyAddress && this.companyAddress.gst_number ? this.companyAddress.gst_number : ""
    let accountingCompanyState = this.companyAddress && this.companyAddress.state_id ? this.companyAddress.state_id : ''
    let accountingCompanyStateId = this.companyAddress && this.companyAddress.state_id ? this.companyAddress.state_id : ''
    if (otherGstNumber && otherGstNumber.length > 0 && otherGstNumber != 'null') {
      //if other's company code is of same as of accounting company then non igst applicable 
      if (accountingCompanyGstNumber.substring(0, 2) == otherGstNumber.substring(0, 2)) {
        return false;
      } else {
        return true;
      }
    } else if ((otherState && otherState.length && otherState.length > 0 && otherState != 'null')) {
      //if other's company state is of same sate then non igst applicable
      if (accountingCompanyState.toUpperCase() == otherState.toUpperCase()) {
        return false;
      } else {
        return true;
      }
      //if other code/state both is undefined then consider it non igst applicable 
  }else if (typeof otherState=='number' && otherState!=0) {
    //if other's company state is of same sate then non igst applicable
    if (accountingCompanyStateId == otherState) {
        return false;
      } else {
        return true;
      }
      //if other code/state both is undefined then consider it non igst applicable 
    } else {
      return false;
    }
  }
  async calculateCommission(base,tax,commType,commFor,commRate,tdsType,tdsRate,roundOffType = "NORMAL_ROUND_OFF",i){
    let res = await this.miscInvoiceService.calculateCommission(base,tax,commType,commFor,commRate,tdsType,tdsRate,roundOffType = "NORMAL_ROUND_OFF",i)
    return res
  }

  async  calculateNetAmount(i){
    var invoiceData = this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].value
    if(Number(invoiceData.client_gst_conf_3)>0 &&( invoiceData.client_sc3_taxable=="T" || invoiceData.client_sc2_taxable=="T" || invoiceData.client_sc1_type=="T")){
      window.scroll(0,0)
      this.showMessage = true;
      this.isSuccess = false
      this.invoice_number = ''
      this.alertType = 'error-box';
      this.message = `To Calculate GST on Total, All Service Charges TAXABLE should be of Type 'N'`
      this.spinner.hide()
      return false
    }
    if(invoiceData.client_sc2_taxable=="T") this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_gst_conf_2.setValue(0)
      if(invoiceData.client_sc3_taxable=="T") this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_gst_conf_3.setValue(0)
      if(invoiceData.supplier_sc2_taxable=="T") this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_gst_conf_2.setValue(0)
      if(invoiceData.supplier_sc3_taxable=="T") this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_gst_conf_3.setValue(0)
        let rcm_applicable = this.miscInvoiceService.invoiceForm.value.rcm_applicable
    let reverse_tds = this.miscInvoiceService.invoiceForm.value.reverse_tds

    let  supplierCommRes = await this.calculateCommission(invoiceData.supplier_basic, invoiceData.supplier_taxes, invoiceData.supplier_commission_type,'SUPPLIER',invoiceData.supplier_commission_value,invoiceData.supplier_tds_type,invoiceData.supplier_tds_conf,'NORMAL_ROUND_OFF',i)
    let  clientCommRes = await this.calculateCommission(invoiceData.client_basic, invoiceData.client_taxes, invoiceData.client_commission_type,'CLIENT',invoiceData.client_commission_value,invoiceData.client_tds_type,invoiceData.client_tds_conf,'NORMAL_ROUND_OFF',i)
    invoiceData = this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].value
    let scRes = await this.calcuateSC(i);
    invoiceData = this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].value
    let client_total = 0
    let client_net_amount = 0
    let supplier_total = 0
    let supplier_net_amount = 0
    let client_sc_amount = Number(invoiceData.client_sc1_amount)+Number(invoiceData.client_sc2_amount)+Number(invoiceData.client_sc3_amount)

    let supplier_sc_amount = Number(invoiceData.supplier_sc1_amount)+Number(invoiceData.supplier_sc2_amount)+Number(invoiceData.supplier_sc3_amount)
    
    if(invoiceData.pay_type != undefined && invoiceData.pay_type.trim && invoiceData.pay_type != 'AGENT_CC' ){
      client_total += Number(invoiceData.client_basic) + Number(invoiceData.client_taxes )
    }
    client_net_amount = client_total - 
                    Number(invoiceData.client_commission_amount)-Number(invoiceData.client_discount_amount)+Number(client_sc_amount) + 
                    Number(invoiceData.invoice_type !='non_account' && invoiceData.client_tds_amount ? invoiceData.client_tds_amount : 0) + 
                    Number(invoiceData.client_igst) + Number(invoiceData.client_cgst) + Number(invoiceData.client_sgst) + Number(invoiceData.client_vat_amount ? invoiceData.client_vat_amount : 0)+
                    Number(invoiceData.client_igst_2) + Number(invoiceData.client_cgst_2) + Number(invoiceData.client_sgst_2)+
                    Number(invoiceData.client_igst_3) + Number(invoiceData.client_cgst_3) + Number(invoiceData.client_sgst_3) +
                    - Number(invoiceData.client_xxl_charges) - Number(invoiceData.client_raf_charges) - Number(invoiceData.client_vat_on_raf) -
                    Number(invoiceData.client_cgst_on_raf) - Number(invoiceData.client_sgst_on_raf) - Number(invoiceData.client_igst_on_raf)

    
    if(invoiceData.pay_type != undefined && invoiceData.pay_type.trim && invoiceData.pay_type.trim().length == 0 ){
      supplier_total += Number(invoiceData.supplier_basic) + Number(invoiceData.supplier_taxes )
      let purchase_currency_rate = Number(this.miscInvoiceService.invoiceForm.controls.purchase_currency_rate.value);
      supplier_total = Number(supplier_total)/Number(purchase_currency_rate)
      supplier_net_amount = supplier_total - 
                            Number(invoiceData.supplier_commission_amount) -Number(invoiceData.supplier_discount_amount) + 
                            Number(invoiceData.invoice_type !='non_account' && invoiceData.supplier_tds_amount ? (reverse_tds==true?  Number(invoiceData.supplier_tds_amount)*-1:invoiceData.supplier_tds_amount): 0) + Number(supplier_sc_amount) + 
                            ( rcm_applicable==true?0:
                            Number(invoiceData.supplier_igst) + Number(invoiceData.supplier_cgst) + Number(invoiceData.supplier_sgst) +  Number(invoiceData.supplier_vat_amount ? invoiceData.supplier_vat_amount : 0)+
                            Number(invoiceData.supplier_igst_2) + Number(invoiceData.supplier_cgst_2) + Number(invoiceData.supplier_sgst_2)+
                            Number(invoiceData.supplier_igst_3) + Number(invoiceData.supplier_cgst_3) + Number(invoiceData.supplier_sgst_3)-
                            Number(invoiceData.supplier_cgst_on_raf) - Number(invoiceData.supplier_sgst_on_raf) - Number(invoiceData.supplier_igst_on_raf)) + 
                            - Number(invoiceData.supplier_xxl_charges) - Number(invoiceData.supplier_raf_charges) - Number(invoiceData.supplier_vat_on_raf) 

    }
    
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.supplier_net_amount.setValue(Number(supplier_net_amount).toFixed(2))
    this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls.client_net_amount.setValue(Number(client_net_amount).toFixed(2))
    
    this.changeSalesCurrencyAmount(null)

  }

  async handlePayTypeChange(event, index){
    let calcLocalRes = await this.calculateNetAmount(index)
    let calcApiRes = await this.miscInvoiceService.calculateFromApi(0)
    this.generalAccountArr =[]
    if(event.target.value == 'OUR_CC'){
			this.getGeneralAccounts()
		}
    if(event.target.value == 'ASSOCIATE_CC'){
      this.getAssociateGeneralAccounts()
    		}
		if(event.target.value != 'OUR_CC' && event.target.value != 'ASSOCIATE_CC'){ 
			let traveller = this.miscInvoiceService.travellerForm.controls.travellerList.controls[index]
			traveller.controls.ledger_card_name.setValue('')
			traveller.controls.ledger_card_no.setValue('')
		}
  }

  replicateClientAmount(i: any, fromFCN,toFCN) {
    let travellerList = this.miscInvoiceService.travellerForm.controls.travellerList
    let account_type = this.miscInvoiceService.invoiceForm.value.invoice_type
    if(
      account_type != 'non_account' && 
      fromFCN && 
      toFCN && 
      travellerList.controls[i] && 
      travellerList.controls[i].controls && 
      travellerList.controls[i].controls[fromFCN] &&
      travellerList.controls[i].controls[toFCN]
      ){
        let purchase_currency = this.miscInvoiceService.invoiceForm.controls.purchase_currency.value;
        let purchase_currency_rate = Number(this.miscInvoiceService.invoiceForm.controls.purchase_currency_rate.value);
        if((fromFCN == 'client_basic' || fromFCN == 'client_taxes' || fromFCN == 'supplier_basic' || fromFCN == 'supplier_taxes') && !this.isTenantIndian && purchase_currency && purchase_currency_rate) {
          if(fromFCN == 'client_basic' || fromFCN == 'client_taxes') {
            travellerList.controls[i].controls[toFCN].setValue((travellerList.controls[i].controls[fromFCN].value * purchase_currency_rate).toFixed(2));
          } else {
            travellerList.controls[i].controls[toFCN].setValue((travellerList.controls[i].controls[fromFCN].value / purchase_currency_rate).toFixed(2));
          }
        } else {
          travellerList.controls[i].controls[toFCN].setValue(travellerList.controls[i].controls[fromFCN].value)
        }
      this.calculateNetAmount(i)
    }
  }

  moveToPreviousTraveller(i) {
		this.showTravellerIndex = i - 1
	}
  moveToNextTraveller(i) {
		this.showTravellerIndex = i + 1
    let nextStep = 1
    let staticCount = 10;
    
    if(this.isTenantIndian) {
      staticCount = 10
    } else {
      staticCount = 12
    }

    if(this.staticInputCount == staticCount){
      nextStep = 2
    }

    if(i == this.miscInvoiceService.travellerForm.controls.travellerList.controls.length){
      this.returnToInvoice()
    }
	}

  returnToInvoice(){  
    if(this.isGstNumberExist){
      this.checkHsn(this.miscInvoiceService.travellerForm.value)
      if(this.isHsnError==true){ 
        window.scroll(0,0)
        this.showMessage = true;
        this.isSuccess = false
        this.invoice_number = ''
        this.alertType = 'error-box';
        this.message = `Enter Hsn Code for all Service Charges`
        this.spinner.hide()
        return false
      }
    }   
		this.minimizeSection()
	
	}

  openReplicateModal(index) {
		// e.stopPropagation();

    let travellerListLength = this.miscInvoiceService.travellerForm.controls.travellerList.controls.length 
    if(this.showTravellerIndex < travellerListLength - 1){
      this.moveToNextTraveller(index)
    } else {
      if (this.openModal["_results"][0]) {
        this.openModal["_results"][0].nativeElement.click()
      }
    }
	}

  replicateFormData(index) {
    let count = index + 1

    let travellerListLength = this.miscInvoiceService.travellerForm.controls.travellerList.controls.length
    
    this.CommissionConfig()
     if(this.showTravellerIndex < travellerListLength - 1){
        this.moveToNextTraveller(index)
    } else {
      this.miscInvoiceService.travellerCountUpdate(travellerListLength+1)
      this.minimizeSection( )
      this.maximizeSection(travellerListLength+1)  
    }
		// let tempFormValue = Object.assign({}, this.miscInvoiceService.travellerForm.value.travellerList[index])
		// let travellerListLength = this.miscInvoiceService.travellerForm.controls.travellerList.controls.length
		// for (let i = 0; i < travellerListLength; i++) {
    //   const travellerList = this.miscInvoiceService.travellerForm.controls.travellerList.controls[i];
    //   if(i >= index){
    //     this.setTravellerData(travellerList, tempFormValue)
    //   }else {
    //     this.setTravellerData({}, tempFormValue)
    //   }
		// }
		// if (this.showTravellerIndex < travellerListLength - 1) {
		// 	this.moveToNextTraveller(index)
		// }
	}

  setTravellerData(travellerList, tempFormValue) {
		let keys = Object.keys(tempFormValue)
		for (let i = 0; i < keys.length; i++) {
			const element = keys[i];
			if ( element != 'reference_number'  && element != 'pay_type' && element != 'ledger_card_no' &&  element != 'ledger_card_name' && element != 'general_ledger_code' && element != 'general_ledger_code_name') {
				travellerList.controls[element].setValue(tempFormValue[element])
			}
      // if(element == 'general_ledger_code_name'){
      //   travellerList.controls[element].setValue(tempFormValue[element])
      // }
		}
	}

  focusClientAc() {
    if (this.clientAC && this.clientAC.focus) {
      this.clientAC.focus()
    }
  }
  focusTourAc(){
    if (this.tourAC && this.tourAC.focus) {
      this.tourAC.focus()
    }
  }
  focusGeneralLedgerAc() {
    if (this.generalLedgerAc && this.generalLedgerAc.focus) {
      this.generalLedgerAc.focus()

    }
  }
  focusNarrationArea() {
    if (this.narrationArea != undefined) {
      this.narrationArea.focus();
    }
  }
  focusSupplierAc() {
    if (this.supplierAc != undefined) {
      this.supplierAc.focus();
    }
  }
  focusSupplier2Ac() {
    if (this.supplier2Ac != undefined) {
      this.supplier2Ac.focus();
    }
  }
  focusSubledgerAc() {
    if (this.subLedgerAC != undefined && this.subLedgerAC.focus) {
      this.subLedgerAC.focus();
    }
  }

  focusEmployeeAc() {
    if (this.employeeAC != undefined) {
      this.employeeAC.focus();
    }
  }

  focusLedgerCardAc() {

  }


  get DynamicFormControls() {
		const travellerList = <FormArray>this.miscInvoiceService.travellerForm.get("travellerList");
		return travellerList;
	}
  maximizeSectionDate(data = null,index,nextStep =1) {
		this.maximizeSection(index,nextStep)
	}
  maximizeSection(index,nextStep =1) {
		this.maximizedSection = true
		this.showTravellerIndex = index
    const invoiceData = this.miscInvoiceService.travellerForm.controls.travellerList.controls[index]

    this.payableSearch(invoiceData.payable_code,index)
	}

  minimizeSection() {
		this.maximizedSection = false
		this.showTravellerIndex = null
    this.miscInvoiceService.calculateFromApi(0)

    this.setNarration()

    this.changeSalesCurrencyAmount(null)
	}

  viewInvoice(invoice_no){
    this.closeSuccesModal()
    this.router.navigate([`/transactions/misc/view/${invoice_no}`])
  }
  openVoucher(invoice_number) {
		let url = `${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/transactions/misc/print;searchId=${invoice_number}`;
		window.open(url, "_blank");
	}

  openActivity(invoice_no) {
		let pathurl=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/activity/activity-summary/misc/${invoice_no}`

		if(window.location.protocol != 'file:'){
			window.open(pathurl,'_blank')
		}else{
			var customeEventHandler = new CustomEvent("handle-window-open", {
				"detail": {
					hashPath : pathurl
				}
			  });
			window.dispatchEvent(customeEventHandler)
		}
	}

  viewJournal(invoice_no) {
    let url = `${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/transactions/view-invoice-journal/${invoice_no}`;
		window.open(url, "_blank");
	}

  async handleInvoiceForChange(value){
    for (const traveller of this.miscInvoiceService.travellerList.controls) {
      traveller['controls'].client_tds_type.setValue(value == 'non_account' ? 'B' : 'C') 
      let res = await this.calculateNetAmount(this.miscInvoiceService.travellerList.controls.indexOf(traveller))
    }
    this.miscInvoiceService.calculateFromApi(0)
    this.invoice_config = this.miscInvoiceService.invoice_config[value] ? this.miscInvoiceService.invoice_config[value] : ""
  }

  handleMaximizeSection(i){
    let staticCount;
    if(this.isTenantIndian) {
      staticCount = 9
    } else {
      staticCount = 11
    }

    if(this.staticInputCount == staticCount){
      this.maximizeSection(i,2)
    }
  }

  closeSuccesModal(){
    this.showMessage = false;
    this.isSuccess = false
    this.alertType = 'success-box';
    this.message = ``
    this.newInvoice = true
    this.openSuccessModal.nativeElement.click()
  }
  resetSelection(formControlName) {
    this.miscInvoiceService.invoiceForm.controls[formControlName].setValue('')
    this.miscInvoiceService.invoiceForm.controls[`${formControlName}_name`].setValue('')
    if(formControlName == 'client_code'){
      this.bookingClientArr = []
    }
    if(formControlName == 'supplier_code'){
      this.bookingSupplierArr = []
    }
  }

  setServiceDate(e){
    if(e.target.value && moment(e.target.value).isValid()){
      this.miscInvoiceService.invoiceForm.controls.service_date.setValue(e.target.value)

    }
  }

  resetCurrentOpenedModal(){
    this.currentOpenedModal = ''
  }
  openDeleteConfirmModal() {
    if(this.commonService.gstFiledDate) {
			if(moment(this.commonService.gstFiledDate).isSameOrAfter(moment(this.invoiceData.invoice_date).format('YYYY-MM-DD')) || moment(this.commonService.gstFiledDate).isSameOrAfter(moment(this.miscInvoiceService.invoiceForm.controls.invoice_date.value).format('YYYY-MM-DD'))) {
				this.showMessage = true
				this.spinner.hide()
				this.alertType = "error-box"
				this.message = 'Not Allowed to delete the invoice.'
				return false;
			}
		}
    this.closeOpenedModals('delete')
    this.currentOpenedModal = 'delete'
		this.confirmDeleteModal.nativeElement.click()
	}
	closeDeleteConfirmModal() {
    this.currentOpenedModal = ''
		this.closeDeleteModal.nativeElement.click()
	}

  openUpdateConfirmModal() {
    if(this.commonService.gstFiledDate) {
			if(moment(this.commonService.gstFiledDate).isSameOrAfter(moment(this.invoiceData.invoice_date).format('YYYY-MM-DD')) || moment(this.commonService.gstFiledDate).isSameOrAfter(moment(this.miscInvoiceService.invoiceForm.controls.invoice_date.value).format('YYYY-MM-DD'))) {
				this.showMessage = true
				this.spinner.hide()
				this.alertType = "error-box"
				this.message = 'Not Allowed to update the invoice.'
				return false;
			}
		}

    if(this.miscInvoiceService.invoiceForm.value.bill_of_supply === true) {
      let checkBosApplicableOrNot = this.checkBosApplicableOrNot(this.miscInvoiceService.travellerForm.value)
      if(!checkBosApplicableOrNot) {
        this.showMessage = true
				this.spinner.hide()
				this.alertType = "error-box"
				this.message = 'Bill of supply Not Applicable.'
				return false;
      }
    }

    this.closeOpenedModals('update')
		this.currentOpenedModal = 'update'
		this.confirmUpdateModal.nativeElement.click()
	}
	closeUpdateConfirmModal() {
		this.currentOpenedModal = ''
		this.closeUpdateModal.nativeElement.click()
	}

  closeOpenedModals(modalName){
		if(modalName!='delete') this.closeDeleteConfirmModal()
		if(modalName!='update') this.closeUpdateConfirmModal()
	}

  deleteInvoice(invoice_no) {
		this.closeDeleteConfirmModal()
		this.commonService.deleteRequest(`${environment.okountUrl}/invoice?invoice_no=${invoice_no}`).subscribe(res => {
			this.showMessage = true
			this.alertType = 'success-box';
			this.message = `Invoice Deleted`
		}, err => {
			this.showMessage = true
			this.alertType = 'error-box';
			this.message = `Failed to delete invoice.`
		})
	}

  openSendEmailModal(){
		//define email.
    let primary_email = ''
    let secondary_email = ''
    let subject = `INVOICE NO. ${this.invoice_no}`
    let body = `Dear Travel Partner,\n\nPlease find Attached Invoice ${this.invoice_no}`
    body+=`\n\nPlease do not hesitate to contact us if you have any query or concern about attached document.\n\nIt's been a pleasure to serve you.\n\nBest Regards\n\n${this.invoiceData.accounting_company?.name}\nAccounts Team`
    if(this.invoiceData.accounting_company && this.invoiceData.accounting_company.telephone){
			body += `\nContact Us on ${this.invoiceData.accounting_company.telephone}`
		}
    if(this.invoiceData && this.invoiceData.client){
      primary_email = this.invoiceData.client.hasOwnProperty('primary_email')?this.invoiceData.client.primary_email:''
      secondary_email = this.invoiceData.client.hasOwnProperty('secondary_email')?this.invoiceData.client.secondary_email:''
    }
    this.sendEmailForm.controls.toEmails.setValue(primary_email)
    this.sendEmailForm.controls.bccEmails.setValue("")
    this.sendEmailForm.controls.ccEmails.setValue(secondary_email?.split(',').join('\n'))
    this.sendEmailForm.controls.subject.setValue(subject)
		this.sendEmailForm.controls.body.setValue(body)
    this.openEmailModal.nativeElement.click();
	}

	callTosendEmail(){
  	
		let toEmails = this.sendEmailForm.value.toEmails
		let bccEmails = this.sendEmailForm.value.bccEmails?.split(",")
		let ccEmails = this.sendEmailForm.value.ccEmails?.split(",")
    let subject = this.sendEmailForm.value.subject
    let body = this.sendEmailForm.value.body
    let clientName = this.invoiceData && this.invoiceData.client && this.invoiceData.client.name?this.invoiceData.client.name:''
		if(toEmails){
      
				toEmails = toEmails.split(",")
				window.scrollTo(0, 0)
				let emails = {
				  to_addresses:toEmails,
				  cc_addresses:ccEmails,
				  bcc_addresses:bccEmails
				}
				let pageUrl = `transactions/misc-invoice/print;searchId=${this.invoice_no}`
				const formData = new FormData();
			formData.append('email',JSON.stringify(emails))
			formData.append('name',clientName)
			formData.append('page_url',pageUrl)
			formData.append('subject',subject)
			formData.append('email_body',body)
			formData.append('document_num',this.invoice_no)
			if(this.attachmentFile){
				formData.append('attachmentFile',this.attachmentFile)
			}
			let data = formData
				this.commonService.fileUpload(`${environment.okountUrl}/send_mail?transaction_type=misc-invoice`,data).subscribe((res : any)=> {
				  this.showMessage = true;
				  this.alertType = 'success-box'
				  this.message = res.msg
				  this.closebutton.nativeElement.click();
				},err => {
				  this.showMessage = true
				  this.alertType = "error-box"
				  this.message = err.msg
				  this.closebutton.nativeElement.click();
				  
				})
			  }
	
	  }


  closeWindow() {
		window.close();
	}

  copytext(val: string) {

    try{
        console.log('Copying:', val); // Debugging
        if (!val) {
            console.warn('No value to copy.');
            return;
        }
		const selBox = document.createElement('textarea');
		selBox.style.position = 'fixed';
		selBox.style.left = '0';
		selBox.style.top = '0';
		selBox.style.opacity = '0';
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		this.copyELementTitle = 'Copied'
    
    } catch (err) {
      console.error('Fallback: Unable to copy text', err);
    }
	}

  testClick(event: Event) {
    console.log('Copy Icon Clicked!', event);
    debugger;  // Stops execution when clicked
}

  changeSalesCurrencyAmount(event) {
    let value =  this.miscInvoiceService.invoiceForm.controls.sales_currency_rate.value;
    let rate =  Number(value ? value : 0);
    if(rate) {
      let client_net_amount =  this.miscInvoiceService.totalFareModel[0].client_net_amount;
      let tcs_amount = Number(this.miscInvoiceService.invoiceForm.controls.tcs_amount.value ? this.miscInvoiceService.invoiceForm.controls.tcs_amount.value : 0);
      let grandTotal = Number(client_net_amount) + Number(tcs_amount ? tcs_amount : 0);
      this.miscInvoiceService.invoiceForm.controls.sales_currency_amount.setValue((grandTotal * rate).toFixed(2));
    } else {
      this.miscInvoiceService.invoiceForm.controls.sales_currency_amount.setValue('');
    }
   }

   getAccountingCompany() {
    try {
      this.invoiceService.getMethod('util/accounting-company').subscribe(async (res) => {
        if(res) {
          if(res['currency_code']) {
            this.currencyCode = res['currency_code'];
          }
          if(res['native_language_code'] && res['currency_code'] == 'AED') {
            this.nativeLanguageCode = res['native_language_code'];
          }
          if(this.invoiceMode != 'view') {
						this.miscInvoiceService.invoiceForm.controls.purchase_currency_rate.setValue(1);
            this.miscInvoiceService.invoiceForm.controls.purchase_currency.setValue(this.currencyCode ? this.currencyCode : '');
					}
          if(res['gst_number']){
						this.isGstNumberExist = true
					}
        }
      },
      err => {
        this.spinner.hide()
      })
    } catch (error) {
      console.log('Error occured in getInvoice due to : ', error)
    }
  }

  clickToPrintOptions() {
		this.showPrintOptions = !this.showPrintOptions;
	}

  checkWhetherEInvGeneratedOrNot(invoice) {
		this.commonService.getRequest(`${environment.okountUrl}/e_invoicing/check-invoice?invoiceNumber=${invoice}`).subscribe((res : any)=>{
			if(res && res['message'] && res['message'] == 'not_generated') {
				this.generateEInvoiceModal.nativeElement.click()
				return false;
			} 

			this.getPdfOfEInvoice(invoice)
		},err=>{
			console.log(err)
		})
	}

  getPdfOfEInvoice(invoice) {
		this.spinner.show()
		this.commonService.downloadPDF(`${environment.okountUrl}/e_invoicing/print/miscellaneous?invoiceNumber=${invoice}&type=misc_invoice&preview=false`, null).subscribe((fileBlob:any) =>{
			let fileName = `E-invoice-${invoice}.pdf` 			
			let blob = new Blob([fileBlob], { 
				type: 'application/pdf'
			});
			this.spinner.hide()
			FileSaver.saveAs(blob, fileName);
	   }, err => {
		    this.spinner.hide()
	   })
	}

  checkWhetherEInvGenerated(invoice) {
		this.commonService.getRequest(`${environment.okountUrl}/e_invoicing/check-invoice?invoiceNumber=${invoice}`).subscribe((res : any)=>{
			if(res && res['message'] && res['message'] == 'not_generated') {
				this.checkEInvoice= false;
			} else{
				this.checkEInvoice= true
			}
			if(this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA')) {
				let userData = JSON.parse(this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA'))
        if(userData.tenant_id && environment.BHUPESH_TENANT.split(',').includes(typeof userData.tenant_id=='number'?userData.tenant_id.toString():userData.tenant_id)){
          this.isTesoyBoult = true
			}
		}
		console.log("isTesoyBoult",this.isTesoyBoult,"checkEInvoice",this.checkEInvoice)
		},err=>{
			console.log(err)
			return false
		})
	}

   checkAssociateTransaction(invoice) {
        this.commonService.getRequest(`${environment.okountUrl}/linked_transaction/checkAssociateTransaction?invoce_no=${invoice}`).subscribe((res : any)=>{
          
            this.associateTransaction= res['message']
        },err=>{
          console.log(err)
          return false
        })
      }
      checkAssociateTransactionOnHQ(invoice) {
        this.commonService.getRequest(`${environment.okountUrl}/linked_transaction/checkAssociateTransactionOnHQ?invoce_no=${invoice}`).subscribe((res : any)=>{
            this.associateTransactionOnHQ= res['message']
        },err=>{
          console.log(err)
          return false
        })
      }

  closeGenerateEInvoiceModal(){
		this.generateEInvoiceModal.nativeElement.click()
	}
  generateEInvoice(invoice) {
		this.spinner.show()
		this.commonService.postRequest(`${environment.okountUrl}/e_invoicing/miscellaneous?invoiceNumber=${invoice}&type=misc_invoice`, null).subscribe((res : any)=> {
			this.showMessage = true;
			this.alertType = 'success-box'
			this.getPdfOfEInvoice(invoice);
		},err => {
			this.showMessage = true
			this.spinner.hide()
			this.alertType = "error-box"
			this.message = err.error && err.error.message ? err.error.message : ''
		})

	}
  handleAttachment(event: any) {
		this.attachmentFile = event.target.files[0];
	  }

    selectEmployee(event, currentIndex){
      if(event && event.nzValue) {
        let value = event.nzValue;
        if(value.account_name) {
          this.miscInvoiceService.travellerForm.controls.travellerList.controls[currentIndex].controls.lead_pax_name.setValue(value.account_name)
        }
        if(value.account_code) {
          this.miscInvoiceService.travellerForm.controls.travellerList.controls[currentIndex].controls.e_code.setValue(value.account_code)
        }
        if(value.cost_center) {
          this.miscInvoiceService.travellerForm.controls.travellerList.controls[currentIndex].controls.cost_center.setValue(value.cost_center)
        }
      }
    }
  
    focusCorporateEmployeeAc() {
      if (this.corporateEmployeeAc && this.corporateEmployeeAc.focus) {
        this.corporateEmployeeAc.focus()
      }
    }
  
    async getCorporateEmployee(event, currentIndex) {
      let val;
      if(event) {
        val = event.target.value;
      }
      if(event && currentIndex != null) {
        if(!val || val == null || val == undefined) {
          const traveller = this.miscInvoiceService.travellerForm.controls.travellerList.controls[currentIndex]
          traveller.controls['lead_pax_name'].setValue('')
          //traveller.controls['employee'].setValue('')
          traveller.controls['e_code'].setValue('')
          traveller.controls['cost_center'].setValue('')
          
          // setTimeout(() => {
          // 	this.calculateFareFromApi(0)
          // }, 100);
        }
      };
      let client_code = this.miscInvoiceService.invoiceForm.controls.client_code.value
      try {
        let url = `util/getCorporateEmployee?&client=${client_code}`
        if(val && val.length > 2){
          url = `util/getCorporateEmployee?name=${val}&client=${client_code}`
        }
        this.invoiceService.getMethod(url).subscribe(data => {
          this.employeeArr = data["data"]
          // this.bookingSupplierArrBase = data;
        }, err => {
          throw new Error(JSON.stringify(err));
        })
      } catch (error) {
        console.log('Error while getting Booking Suppliers : ', error)
  
      } 
    }
    getTotalDays(data = null){
         let start_date = this.miscInvoiceService.invoiceForm.controls.departure_date.value
         let end_date = this.miscInvoiceService.invoiceForm.controls.arrival_date.value
         if(start_date && end_date){
           let days = moment(end_date).diff(moment(start_date), 'days');
           this.miscInvoiceService.invoiceForm.controls.total_days.setValue(days)
         }else{
           this.miscInvoiceService.invoiceForm.controls.total_days.setValue(0)
   
         }
   
       }

    openBosReference() {
      if(this.invoiceData && this.invoiceData.bos_reference) {
        let url = `${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/transactions/misc/view/${this.invoiceData.bos_reference}`;
        window.open(url, "_blank");
      }
    }

    checkBosApplicableOrNot(product_json_doc) {
      if(product_json_doc.travellerList.length>0) {
        for(let item of product_json_doc.travellerList) {
          let gst_amount = Number(item.client_igst) + Number(item.client_cgst) + Number(item.client_sgst);
          if((item.client_gst_type == 'S' && Number(gst_amount) > 0) == false) {
            return false;
          }
        }
        return true;
      }
    }

    checkHsn(invoice_product) {
      this.isHsnError = false
      if (invoice_product && invoice_product.travellerList) {
        for (let item of invoice_product.travellerList) {
          if (item.client_cgst != 0 || item.client_sgst != 0 || item.client_igst != 0) {
            if (!item.hsn) {
              this.isHsnError = true
            }
          }
            if (item.client_cgst_2 != 0 || item.client_sgst_2 != 0 || item.client_igst_2 != 0 || (item.client_sc2_taxable=='T' && item.client_sc2_amount != 0)) {
              if (!item.hsn_2) {
                this.isHsnError = true
              }
            }
            if (item.client_cgst_3 != 0 || item.client_sgst_3 != 0 || item.client_igst_3 != 0 || (item.client_sc3_taxable=='T' && item.client_sc3_amount != 0)) {
              if (!item.hsn_3) {
                this.isHsnError = true
              }
            }
        }
       
        
      }
    }

    selectSalesPerson(nzEvent, formControlName) {
      let nzValue = nzEvent.nzValue;
      let value = nzValue;
        try {
          if(formControlName == 'sales_person_name') {
          this.miscInvoiceService.invoiceForm.controls.sales_person_name.setValue(value.t_user_name)
          this.miscInvoiceService.invoiceForm.controls.sales_person_code.setValue(value.user_code)
    return;
          }
          
        } catch (error) {}
    }
   
   
    salesPersonSearch(event) {
      try {
          this.invoiceService
            .searchAccount(
              `user/salesPerson?names_like=${event.target.value||''}`
            )
            .subscribe(
              (res) => {
                this.salesPersonArr = res;
              },
              (error) => {}
            );
      } catch (error) {}
    }
    referedBySearch(event) {
      try {
          this.invoiceService
            .searchAccount(
              `employee/autocomplete?name_like=${event.target.value||''}`
            )
            .subscribe(
              (res) => {
                this.referedByArr = res;
              },
              (error) => {}
            );
      } catch (error) {}
    }

    costCenterSearch(event) {
      try {
          this.invoiceService
            .searchAccount(
              `costCenter?names_like=${event.target.value||''}`
            )
            .subscribe(
              (res) => {
                this.groupList = res['data'];
              },
              (error) => {}
            );
      } catch (error) {}
    }

    validateSalesPerson(inputValue: string):void {
      const isValid = this.salesPersonArr.some(item => item.t_user_name === inputValue);
      if (!isValid) {
        this.miscInvoiceService.invoiceForm.controls.sales_person_name.setValue(''); // Clear the invalid input
        this.miscInvoiceService.invoiceForm.controls.sales_person_code.setValue('')
        
      }
    }
    openBill(invoice){
      this.spinner.show()
      this.commonService.downloadPDF(`${environment.okountUrl}/invoice/misc-invoice/download/${invoice}?currency_bill=true&preview=false`, null).subscribe((fileBlob:any) =>{
        let fileName = `CURRENCY-BILL-${invoice}.pdf` 			
        let blob = new Blob([fileBlob], { 
          type: 'application/pdf'
        });
        this.spinner.hide()
        FileSaver.saveAs(blob, fileName);
       }, err => {
          this.spinner.hide()
       })
    }
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      this.uniqueSupplier = []
      
  const travellerList = this.miscInvoiceService.travellerForm.controls.travellerList.controls;

  this.uniqueSupplier = travellerList.reduce((acc, curr) => {
    const payableCode = curr.get('payable_code')?.value;
    const payableName = curr.get('payable_account_name')?.value;

    if (payableCode) {
      if (!acc[payableCode]) {
        acc[payableCode] = [];
        acc[payableCode].push({
          name: payableName,
          code: payableCode,
        });
      }
    }
    console.log("uniqueSupplier",this.uniqueSupplier)
    return acc;
  }, {});
    }

  
    validateCostCenter(inputValue: string): void {
      const isValid = this.groupList.some(item => item.name === inputValue);
      if (!isValid) {
        this.miscInvoiceService.invoiceForm.controls.invoice_cost_center.setValue(''); // Clear the invalid input
        
      }
    }

    changeAmount(formControlName,i){
      if(this.isGSTInclusive=='true'){
        const invoiceData = this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].value
      let gstRate = this.getGstRate(i)
      let gst_rate=18
      if(formControlName=='supplier_sc1_amount'){
        gst_rate = invoiceData.supplier_sc1_type=='T'?Number(gstRate.supplier_gst_rate):0
      }
      if(formControlName=='client_sc1_amount'){
        gst_rate = invoiceData.client_sc1_type=='T'?Number(gstRate.client_gst_rate):0
      }
      const amount = Number(invoiceData[formControlName]) || 0; // Default to 0 if undefined or invalid
  const gstExclusiveAmount = (amount * 100) / (gst_rate + 100);
      this.miscInvoiceService.travellerForm.controls.travellerList.controls[i].controls[formControlName].setValue(Number(gstExclusiveAmount.toFixed(2)))
    }
      this.calculateNetAmount(i)
    }

    selectReferedBy(nzEvent, formControlName) {
      let nzValue = nzEvent.nzValue;
      let value = nzValue;
        try {
          if(formControlName == 'refered_by_name') {
            this.miscInvoiceService.invoiceForm.controls.refered_by_name.setValue(value.name)
            this.miscInvoiceService.invoiceForm.controls.refered_by_code.setValue(value.account_code)
    return;
          }
          
        } catch (error) {}
    }

    validateReferedby(inputValue: string,) {
      const isValid = this.referedByArr.some(item => item.name === inputValue);
      if (!isValid) {
        this.miscInvoiceService.invoiceForm.controls.refered_by_name.setValue(''); // Clear the invalid input
        this.miscInvoiceService.invoiceForm.controls.refered_by_code.setValue('')
        
      }
    }

    getCountries() {
      this.commonService.getOkount(`location/country`).subscribe(res => {
        this.countryArr = res
      })
    }

    onItemSelect(item: any) {
      console.log(item);
    }
    onSelectAll(items: any) {
      console.log(items);
    }

     isValidJSON(str: string): boolean {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    }
     openAccountPage(){    
            let path = `${
              environment.name == "v3-stage" || environment.name == "v3-prod"
              ? "/v3/"
              : "/"
            }#/report/adjusted-receipts?account_code=${this.miscInvoiceService.invoiceForm.controls['client_code'].value}&adjustment_reference=${this.invoice_no}&reference_type=invoice`
             
            if(window.location.protocol != 'file:') {
              window.open(path, '_blank')
            }
            }
            openSupplierPage(supplierCode){    
            let path = `${
              environment.name == "v3-stage" || environment.name == "v3-prod"
              ? "/v3/"
              : "/"
            }#/report/adjusted-receipts?account_code=${supplierCode}&adjustment_reference=${this.invoice_no}&reference_type=invoice`
             
            if(window.location.protocol != 'file:') {
              window.open(path, '_blank')
            }
            }
            openKnockOffPage(){    
                let path = `${
                  environment.name == "v3-stage" || environment.name == "v3-prod"
                  ? "/v3/"
                  : "/"
                }#/report/adjust-balance?account_code=${this.miscInvoiceService.invoiceForm.controls.client_code.value}&adjustment_reference=${this.invoice_no}&reference_type=invoice`
                 
                if(window.location.protocol != 'file:') {
                  window.open(path, '_blank')
                }
                }
                 openSupplierKnockOffPage(supplierCode){    
                    let path = `${
                      environment.name == "v3-stage" || environment.name == "v3-prod"
                      ? "/v3/"
                      : "/"
                    }#/report/adjust-balance?account_code=${supplierCode}&adjustment_reference=${this.invoice_no}&reference_type=invoice`
                     
                    if(window.location.protocol != 'file:') {
                      window.open(path, '_blank')
                    }
                    }
}
